/**
 * @file Payment update page — the payment's cards, its editable form and its charge links.
 * `save` reads the child form's state, so it calls `updateParentState` before building the payload.
 */
import * as React from 'react';
import { connect } from 'react-redux';
import Component from '../../AbstractComponent';
import Constants from '../../../Action/Constants';
import Time from '../../../Time/Time';
import PaymentTypeContainer from '../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer';
import { PaymentInterface } from '../../../Entity/Entities/Payment/PaymentInterface';
import { ChargeInterface } from '../../../Entity/Entities/Charge/ChargeInterface';
import { PropertyInterface } from '../../../Entity/Entities/Property/PropertyInterface';
import { UnitInterface } from '../../../Entity/Entities/Unit/UnitInterface';
import { ContractInterface } from '../../../Entity/Entities/Contract/ContractInterface';
import { PromptDialog } from '../../Partials/Dialog/PromptDialog';
import { LeavePromptDialog } from '../../Partials/Dialog/LeavePromptDialog';
import { DeleteEntityPrompt } from '../../Partials/Dialog/DeleteEntityPrompt';
import { MiddlewareInterface } from '../../../Middleware/MiddlewareInterface';
import Charges2List from '../../Partials/Charge/Charges2List';
import Card from '@material-ui/core/Card';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '../../Partials/Material/TextField';
import PaymentUpdateWillMount from '../../../Middleware/Middlewares/PaymentUpdateWillMount';
import PreventPageLeave from '../../../Middleware/Middlewares/PreventPageLeave';
import { Property } from '../../../Entity/Entities/Property/Property';
import { Unit } from '../../../Entity/Entities/Unit/Unit';
import { Contract } from '../../../Entity/Entities/Contract/Contract';
import { Event } from '../../../Entity/Entities/Event/Event';
import TypeContainer from '../../../Entity/Entities/Charge/Type/TypeContainer';
import { Company } from '../../../Entity/Entities/Company/Company';
import { Person } from '../../../Entity/Entities/Person/Person';
import { PageTransition } from '../../Partials/Spinner/PageTransition';
import { PersonInterface } from '../../../Entity/Entities/Person/PersonInterface';
import { CompanyInterface } from '../../../Entity/Entities/Company/CompanyInterface';
import Formatter from '../../../Localization/Formatter';
import * as moment from 'moment';
import { Timeline } from '../../Partials/Timeline/Timeline';
import PaymentClassContainer from '../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer';
import ChargeClassContainer from '../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer';
import { EventInterface } from '../../../Entity/Entities/Event/EventInterface';
import Store from '../../../Store/Store';
import EntityLaunchpanel from '../../Partials/Launchpanel/EntityLaunchpanel';
import { SettleWithSavingsDialog } from '../../Partials/Dialog/SettleWithSavingsDialog';
import { UndoSettleWithSavingsDialog } from '../../Partials/Dialog/UndoSettleWithSavingsDialog';
import Memo from '../../Partials/Memo/Memo';
import Charge2Card from '../../Partials/Charge/Charge2Card';
import Payment2Card from '../../Partials/Payment/Payment2Card';
import ChargeCreateDialog from '../../Partials/Dialog/ChargeCreateDialog';
// import Payments2List from "../../Partials/Payment/Payments2List";
import { CoachNewCounterpartyDialog } from '../../Partials/Dialog/CoachNewCounterpartyDialog';
import { CoachPaymentCostsForAgency } from '../../Partials/Dialog/CoachPaymentCostsForAgency';
import { CoachSettlePayment } from '../../Partials/Dialog/CoachSettlePayment';
import PaymentCounterpartyDescriptionInfoForList from '../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList';
import CoachNewChargeBasedOnPayment from '../../Partials/Dialog/CoachNewChargeBasedOnPayment';

class PaymentUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_PAYMENT_UPDATE_CLEAR;
  public noteField: null;
  public paymentDetails;

  protected middlewares: MiddlewareInterface[] = [
    PaymentUpdateWillMount,
    PreventPageLeave,
  ];

  protected selectedCharge: ChargeInterface;

  public state = {
    events: [],
    linkedCharges: [],
    relatedCharges: [],
    settledPayments: [],
    payment: null,
    renderDetails: true,
    renderChargeType: true,
    isFetchingPayment: true,
    isFetchingCharges: true,
    paymentDetails: null,

    // payment
    paymentChoice: '',
    amountForPayment: '',
    currencyIdForPayment: null,
    firstDateOfStatementPeriodForPayment: new Date(),
    typeIdForPayment: String(PaymentTypeContainer.pickIdFromLabel('Bank')),
    agencyBankAccountIdForPayment: null,
    counterpartyIbanForPayment: '',
    originalCounterpartyIban: null,
    companyBankIdForPayment: '',
    paymentClassId: null,
    payerChoice: 'person',
    existingPayerChoice: 'person',
    selectedPersonForPayment: null,
    selectedCompanyForPayment: null,
    selectedPersonForExistingPayments: null,
    selectedCompanyForExistingPayments: null,
    descriptionForPayment: '',
    descriptionForPaymentIsManuallyChanged: false,
    directIndirectPayments: [],
    payerPayments: [],
    selectedDirectIndirectPaymentsRows: [],
    selectedPayerPaymentsRows: [],
    fetchedPayments: [],
    paymentIds: [],
    anchorPaymentEl: null,
    isPaymentUnSettlePopupOpen: false,
    isPaymentUnlinkPopupOpen: false,
    isPaymentRemovePopupOpen: false,
    dateOfThePayment: new Date(),
    isProcessed: false,
    renderSelectCounterpartyFields: false,
    clearCounterpartyState: false,
    paymentToAddNote: null,
    note: '',
    memoPopupOpen: false,
    showPaymentCardSummaryView: this.props.paymentCardView.summaryView,
    selectedEntityForNewCharge: null,
    openCoachUpdateCounterparty: false,

    // charge
    chargeChoice: 'existing',
    amountForCharge: '',
    invoiceDateForCharge: new Date(),
    invoiceNumberForCharge: '',
    vatForCharge: '',
    vatPercentageForCharge: '',
    isInvoice: false,
    currencyIdForCharge: null,
    chargeOwnerChoice: 'person',
    selectedPersonForCharge: null,
    selectedCompanyForCharge: null,
    selectedCounterpartyForPayment: null,
    typeIdForCharge: null,
    typeIdForCostsCharge: TypeContainer.pickIdFromLabel('Other_payable'),
    counterpartyForCostsCharge: null,
    openCoachCreateNewCounterparty: false,
    selectedEntityForCharge: null,
    selectedEntityForExistingCharge: null,
    periodForCharge: 3, //todo: fix hardcoded value
    firstDateForCharge: null,
    descriptionForCharge: '',
    showChargeOwnerChoice: true, //hack to rerender charge owner lookups
    directIndirectCharges: [],
    objectCharges: [],
    selectedDirectIndirectChargesRows: [],
    selectedObjectChargesRows: [],
    chargeIds: [],
    isChargeFullyPaid: false,
    descriptionForChargeIsManuallyChanged: false,
    typeLabelForCharge: null,
    selectedEntityForChargeManuallyChanged: false,
    typeIdForChargeManuallyChanged: false,
    chargeClassId: null,
    selectedSecondChargeToSettleId: [],

    // popups
    isChooseExistingPaymentPopupOpen: false,
    changeCounterpdartyIbanPopupOpen: false,
    createExtraPaymentPopupOpen: false,
    additionalChargePopupOpen: false,
    isCreateChargeTypePopupOpen: false,
    isUndoSavingsPopupOpen: false,

    //
    isSaving: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    nextPath: '',
    shouldReplacePath: false,
    counterpartyIbanForPaymentWasChanged: false,
    counterpartyIbanForPaymentIsManuallyChanged: false,
    ibanUsedForEntity: null,
    ibanWasChanged: false,
    shouldSettleTheDifference: false,
    shouldCreateExtraPayment: false,
    skipCreateExtraPayment: false,
    detailsForExtraPaymentPopup: {},
    shouldCreateAdditionalCharge: false,
    skipCreateAdditionalCharge: false,
    detailsForAdditionalChargePopup: {
      additionalChargeInformationText: '',
    },
    additionalChargeTypeId: null,
    additionalChargeDescription: null,
    chargeTypeSelectField: 'Receivable',
    isItemSelected: null,
    chargeChoiceIsManuallyChanged: false,
    chargeToDelete: null,
    typeNameForPayment: 'Bank',
    chargeToUnlink: null,
    chargeToUnrefund: null,
    anchorEl: null,
    isSettle: false,
    hasSettlementType: false,
    selectedPayment: null,
    fetchingEvents: true,
    isChargeUnlinkPopupOpen: false,
    isChargeUnrefundPopupOpen: false,
    considerUsedProcessDescription: '',
    isAgencyCostsPopupOpen: false,
    numberOfLinkedAgencyFees: null,
    considerUsedProcess: false,
    hasSavingsType: false,
    isLaunchPanelOpen: false,
    isPaymentSettleWithSavingsPopupOpen: false,
    isRefundPopupOpen: false,
    refundProcess: false,
    refundProcessAmount: '',
    refundProcessDescription: this.trans('refund_receivable'),
    settleSavingScenarioMessage: '',
    isErrorLaunchPanelOpen: false,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    isSettlePaymentPopupOpen: false,
    paymentSearchString: '',
    paymentSearchInProgress: false,
    chargeSearchString: '',
    chargeSearchInProgress: false,
    filteredPayments: [],
    selectedFilteredPaymentsRows: [],
    showAllFields: false,
    showHintBox: false,
    showChargesList: false,
    tabChoice: null,
    entityToUnsettleWithSavings: null,
  };

  constructor(public props) {
    super(props);

    this.paymentDetails = React.createRef();
  }

  public componentWillUnmount() {
    // this.props.dispatch({
    //   type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
    //   payload: {
    //     payments: [],
    //     index: 0
    //   }
    // });

    this.props.dispatch({
      type: Constants.RESET_PAYMENT_CARD_ON_DETAILED_VIEW,
    });

    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);

    if (
      !this.props?.payments?.requestsOutdated &&
      nextProps?.payments?.requestsOutdated
    ) {
      this.initializePage(id);
    }

    if (prevId !== id) {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR,
      });
      this.initializePage(id);
    }
  }

  public initializePage = (id: number, callback = () => {}) => {
    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE,
      payload: {
        paymentId: id || this.state.payment?.id,
      },
      onSuccess: (payment: PaymentInterface) => {
        if (!payment) {
          return this.redirectBack();
        }

        if (
          payment.removed &&
          payment?.paymentType?.id ===
            PaymentTypeContainer.pickIdFromLabel('Savings_account') &&
          this.browser.history.getPreviousPage()
        ) {
          // Add this part, because we automatic deleted payment and charge(savings account logic), and redirectBack() not work correct, we stay at removed payment.
          return this.redirectBack();
        }

        this.fetchEntityEvents(id);

        let typeIdForCharge: number;
        let typeLabelForCharge: string;

        if (
          payment.paymentClass.id ==
          PaymentClassContainer.pickIdFromLabel('Payable')
        ) {
          typeIdForCharge = TypeContainer.pickIdFromLabel('Other_payable');
          typeLabelForCharge = 'Other_payable';
        } else {
          typeIdForCharge = TypeContainer.pickIdFromLabel('Other_receivable');
          typeLabelForCharge = 'Other_receivable';
        }

        const isSettle = payment && payment.isSettle;
        const hasSettlementType =
          payment?.paymentType?.id ===
          PaymentTypeContainer.pickIdFromLabel('Settlement');
        const hasSavingsType =
          payment?.paymentType?.id ===
          PaymentTypeContainer.pickIdFromLabel('Savings_account');

        const linkedCharges: ChargeInterface[] = [
          ...payment.linkedCharges,
        ].filter((charge: ChargeInterface) => !!charge && !charge.removed);
        const settlementCharges: ChargeInterface[] = linkedCharges.filter(
          (charge: ChargeInterface) => charge.hasSettlementType
        );
        const relatedCharges: ChargeInterface[] = [
          ...payment.relatedCharges,
        ].filter((charge: ChargeInterface) => !!charge && !charge.removed);
        const settledPayments = [];
        settlementCharges.forEach((charge: ChargeInterface) => {
          const settledPaymentId = charge.paymentIds.find(
            (id) => id !== payment?.id
          );

          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE,
            payload: {
              paymentId: settledPaymentId,
            },
            onSuccess: (payment: PaymentInterface) => {
              const settledPayments = [...this.state.settledPayments];
              const settledPayment = settledPayments.find(
                (paymentObject) => paymentObject?.payment?.id === payment?.id
              );

              if (!settledPayment) {
                settledPayments.push({
                  payment: payment,
                });
              }
              this.setState({
                settledPayments: settledPayments,
              });
            },
          });
        });

        let state = {
          // payment
          payment: payment,
          linkedCharges: [...linkedCharges],
          relatedCharges: [...relatedCharges],
          settledPayments: [...settledPayments],
          amountForPayment: Formatter.simpleFormatNumber(payment.amount),
          currencyIdForPayment: payment.currency.getCurrencyId(),
          firstDateOfStatementPeriodForPayment:
            payment.firstDateOfStatementPeriod,
          dateOfThePayment: payment.dateOfThePayment,
          typeIdForPayment: String(payment.paymentType.id),
          selectedCounterpartyForPayment: payment?.counterparty,
          agencyBankAccountIdForPayment: payment.agencyBankAccount,
          counterpartyIbanForPayment: payment.mainBankAccountId,
          originalCounterpartyIban: payment.mainBankAccountId,
          companyBankId: payment.parsedTransactionDescription?.['INCASSANT'],
          paymentClassId: String(payment.paymentClass.id),
          payerChoice: payment.company ? 'company' : 'person',
          selectedPersonForPayment: payment.person,
          selectedCompanyForPayment: payment.company,
          descriptionForPayment: payment.description,
          descriptionForPaymentIsManuallyChanged: false,
          isSettle: isSettle,
          hasSettlementType: hasSettlementType,
          isProcessed: payment.isProcessed,
          hasSavingsType: hasSavingsType,
          isSaving: false,
          //charge
          chargeChoice: 'existing',
          directIndirectCharges: [],
          objectCharges: [],
          selectedDirectIndirectChargesRows: [],
          selectedObjectChargesRows: [],
          selectedEntityForExistingCharge: null,
          amountForCharge: !!payment
            ? Formatter.simpleFormatNumber(payment.amountRemaining)
            : '',
          invoiceDateForCharge: new Date(),
          invoiceNumberForCharge: '',
          vatForCharge: '',
          vatPercentageForCharge: '',
          isInvoice: false,
          currencyIdForCharge: payment.currency.getCurrencyId(),
          showChargeOwnerChoice: true, //hack to rerender charge owner lookups
          chargeOwnerChoice:
            !!payment && !!payment.company ? 'company' : 'person',
          selectedPersonForCharge: payment.person,
          selectedCompanyForCharge: payment.company,
          typeIdForCharge: typeIdForCharge,
          selectedEntityForCharge: null,
          periodForCharge: 3, //todo: fix hardcoded value
          firstDateForCharge: Time.firstDateSelectedMonth(
            payment.firstDateOfStatementPeriod
          ),
          descriptionForCharge: !!payment ? payment.description : '',
          typeLabelForCharge: typeLabelForCharge,
          chargeIds: [],
          selectedEntityForChargeManuallyChanged: false,
          typeIdForChargeManuallyChanged: false,
          isCreateChargeTypePopupOpen: false,
          name: payment?.name,

          shouldSettleTheDifference: false,
          shouldCreateExtraPayment: false,
          skipCreateExtraPayment: false,
          detailsForExtraPaymentPopup: {},
          shouldCreateAdditionalCharge: false,
          skipCreateAdditionalCharge: false,
          detailsForAdditionalChargePopup: {},
          additionalChargeTypeId: null,
          additionalChargeDescription: null,
          openLeavePrompt: false,
          nextPath: '',
          shouldReplacePath: false,
          isChargeUnlinkPopupOpen: false,
          isChargeUnrefundPopupOpen: false,
          chargeToUnlink: null,
          chargeToUnrefund: null,
          anchorEl: null,
          isFetchingPayment: false,
          renderDetails: false,
          hasModifiedData: false,
          considerUsedProcessDescription: this.trans(
            'page/paymentupdate-preprocess/considerprocess-description'
          ),
          refundProcessAmount: Formatter.simpleFormatNumber(
            payment.amountRemaining
          ),
          isErrorLaunchPanelOpen: false,
          isSettlePaymentPopupOpen: false,
          paymentSearchString: '',
          paymentSearchInProgress: false,
          chargeSearchString: '',
          chargeSearchInProgress: false,
          filteredPayments: [],
          selectedFilteredPaymentsRows: [],
          counterpartyForCostsCharge: payment?.counterparty,
          openCoachUpdateCounterparty: false,
          showChargesList: false,
          tabChoice: null,
        };

        if (
          Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length >
          0
        ) {
          const createdPerson: PersonInterface =
            this.props.app.savedDataBeforeRedirecting.createdPerson;
          const createdCompany: CompanyInterface =
            this.props.app.savedDataBeforeRedirecting.createdCompany;

          state = {
            ...state,
            ...this.props.app?.savedDataBeforeRedirecting?.[
              `paymentUpdate-${payment?.id}-DataToBeSaved`
            ],
            payerChoice: createdCompany ? 'company' : 'person',
            chargeOwnerChoice: createdCompany ? 'company' : 'person',
          };

          if (!!createdPerson) {
            state.selectedPersonForCharge = createdPerson;
            state.selectedPersonForPayment = createdPerson;
            state.hasModifiedData = true;
          }

          if (!!createdCompany) {
            state.selectedCompanyForCharge = createdCompany;
            state.selectedCompanyForPayment = createdCompany;
            state.hasModifiedData = true;
          }

          if (
            !!this.props.app.savedDataBeforeRedirecting
              .bankTransactionVerificationDataToBeSaved
              ?.selectedPersonForPayment ||
            !!this.props.app.savedDataBeforeRedirecting
              .bankTransactionVerificationDataToBeSaved
              ?.selectedCompanyForPayment
          ) {
            state.hasModifiedData = true;
          }
        }

        this.setState(
          {
            ...state,
          },
          () =>
            this.setState({ renderDetails: true }, () => {
              this.fetchExistingCharges(true);
              callback();
            })
        );
      },
      onError: () => {
        return this.redirectBack();
      },
    });
  };

  public updateChargeSearchString = (chargeSearchString: string) => {
    this.setState(
      {
        chargeSearchString: chargeSearchString,
      },
      this.fetchExistingCharges
    );
  };

  public updatePaymentSearchString = (paymentSearchString: string) => {
    this.setState(
      {
        paymentSearchString: paymentSearchString,
      },
      this.fetchExistingPayments
    );
  };

  public fetchExistingPayments = (firstAutoCall?: boolean): void => {
    const paymentClassId = this.state.payment?.isPaid
      ? PaymentClassContainer.pickIdFromLabel('Receivable')
      : PaymentClassContainer.pickIdFromLabel('Payable');

    const mainPayload: any = {
      paymentClassId: paymentClassId,
      isFullyUsed: 0, // unused payments
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    // manually search payments for settling
    if (!!this.state.paymentSearchString) {
      this.setState(
        {
          paymentSearchInProgress: true,
        },
        () => {
          const payload = {
            ...mainPayload,
            filterValue: this.state.paymentSearchString,
          };

          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
            payload: { ...payload },
            onSuccess: (data) => {
              this.setState({
                payerPayments: data.payments,
                paymentSearchInProgress: false,
              });
            },
          });
        }
      );
    } else {
      this.setState({
        payerPayments: [],
        paymentSearchInProgress: false,
      });
    }

    // should find payment for settle with the same counterparty
    if (!!this.state.selectedCounterpartyForPayment) {
      const payload = {
        ...mainPayload,
      };

      if (this.state.selectedCounterpartyForPayment instanceof Person) {
        payload.contactId = this.state.selectedCounterpartyForPayment?.id;
      }

      if (this.state.selectedCounterpartyForPayment instanceof Company) {
        payload.companyId = this.state.selectedCounterpartyForPayment?.id;
      }

      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_NOT_SAVE_LIST,
        payload: { ...payload },
        onSuccess: (data) => {
          this.setState(
            {
              directIndirectPayments: data.payments,
            },
            () => {
              if (firstAutoCall && this.state.directIndirectPayments.length) {
                this.setState({
                  paymentChoice: 'existing',
                });
              }
            }
          );
        },
      });
    }
  };

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        paymentId: entityId,
      },
      onSuccess: (data) => {
        const paymentEvents: EventInterface[] = data.events.filter(
          (event: EventInterface) => !event.removed
        );

        this.setState({
          events: [...paymentEvents],
          fetchingEvents: false,
        });
      },
    });
  };

  public clearRenderSelectCounterpartyFields = () => {
    this.setState({
      renderSelectCounterpartyFields: false,
    });
  };

  public changeRenderSelectCounterpartyFields = () => {
    this.setState({
      renderSelectCounterpartyFields: true,
    });
  };

  public selectCounterpartyForCostsCharge = (
    entity: CompanyInterface | PersonInterface
  ): void => {
    this.setState({
      counterpartyForCostsCharge: entity,
    });
  };

  public clearCounterpartyForCostsCharge = (): void => {
    this.setState({
      counterpartyForCostsCharge: null,
    });
  };

  public checkIfRefundIsPossible = (payment: PaymentInterface): any => {
    if (!payment) {
      return;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_REFUND_CHECK_START,
      payload: {
        payment: payment,
      },
      onSuccess: () => {
        this.setState({
          isRefundPopupOpen: true,
          refundProcess: true,
          anchorPaymentEl: null,
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          anchorEl: null,
        });
      },
    });
  };

  public refund = (payment: PaymentInterface): void => {
    if (!payment) {
      return;
    }

    this.setState({
      refundProcess: false,
    });

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_REFUND_START,
        payload: {
          payment: payment,
          amount: parseFloat(
            parseFloat(
              String(
                Formatter.deleteExtraSpace(this.state.refundProcessAmount)
              ).replace(',', '.')
            ).toFixed(2)
          ),
          description: this.state.refundProcessDescription,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          return this.initializePage(this.state.payment?.id);
        },
        onError: () => {
          this.setState({
            isSaving: false,
            anchorEl: null,
          });
        },
      });
    });
  };

  public payNewChargeWithPayment = (payment: PaymentInterface): void => {
    const chargeClassId: number =
      this.props.globalTypes?.ChargeType?.[this.state.typeIdForCharge]
        ?.chargeClassId;

    if (chargeClassId !== payment.paymentClass.id) {
      this.setState({ hasModifiedData: true, isSaving: false });

      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans(
            'preprocess/cannotpaycharge-info/differentclasses'
          ),
          type: 'warning',
        },
      });
    }

    const charge: any = {
      amount: parseFloat(
        parseFloat(
          String(
            Formatter.deleteExtraSpace(this.state.amountForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      ),
      amountRemaining: parseFloat(
        (
          100 *
          parseFloat(
            String(
              this.formatter.deleteExtraSpace(this.state.amountForCharge)
            ).replace(',', '.')
          )
        ).toFixed(2)
      ),
      currency: this.state.currencyIdForCharge,
      type: this.state.typeIdForCharge,
      period: this.state.periodForCharge,
      firstDate: Time.formatOrNull(this.state.firstDateForCharge),
      dueDate: Time.formatOrNull(payment.dateOfThePayment),
      description: this.state.descriptionForCharge,
      paymentId: payment.id,
      payment: payment,
      invoiceDate:
        Time.formatOrNull(this.state.dateOfThePayment) ||
        Time.formatOrNull(this.state.invoiceDateForCharge),
      invoiceNumber: this.state.invoiceNumberForCharge,
      vat: parseFloat(
        parseFloat(
          String(Formatter.deleteExtraSpace(this.state.vatForCharge)).replace(
            ',',
            '.'
          )
        ).toFixed(2)
      ),
      isInvoice: this.state.isInvoice,
    };

    if (this.state.selectedEntityForCharge instanceof Property) {
      charge.propertyId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Unit) {
      charge.unitId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Contract) {
      charge.contractId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Company) {
      charge.ownerId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Event) {
      charge.eventId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedPersonForCharge?.id) {
      charge.contactId = this.state.selectedPersonForCharge?.id;
    }

    if (this.state.selectedCompanyForCharge?.id) {
      charge.companyId = this.state.selectedCompanyForCharge?.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_START,
        payload: {
          charge: charge,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
          });

          return this.initializePage(this.state.payment?.id);
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false,
            skipCreateExtraPayment: false,
            skipCreateAdditionalCharge: false,
            shouldCreateExtraPayment: false,
            shouldCreateAdditionalCharge: false,
            shouldSettleTheDifference: false,
            anchorEl: null,
          });
        },
      });
    });
  };

  public linkPaymentWithCharges = (
    paymentId: number,
    chargeIds: number[]
  ): void => {
    this.saving(() => {
      // if some of selected existing charges isfullypaid we should show dialog
      let selectedFullyPaid = false;
      this.state.chargeIds.forEach((id) => {
        const selectedCharge =
          this.state.directIndirectCharges.find((charge) => charge.id === id) ||
          this.state.objectCharges.find((charge) => charge.id === id);

        if (selectedCharge?.isFullyPaid?.()) {
          selectedFullyPaid = true;
        }
      });

      if (selectedFullyPaid) {
        this.setState({
          isSaving: false,
        });

        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans('dialog/extracharge-info/chargeisfullypaid'),
            type: 'warning',
          },
        });
      }

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
        payload: {
          chargeId: chargeIds[0],
        },
        onSuccess: (charge: ChargeInterface) => {
          const chargeClassId: number = charge?.chargeClass?.id;

          if (chargeClassId !== this.state?.payment?.paymentClass?.id) {
            this.setState({ hasModifiedData: true, isSaving: false });

            return this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans(
                  'preprocess/cannotpaycharge-info/differentclasses'
                ),
                type: 'warning',
              },
            });
          }

          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENT_LINK_START,
            payload: {
              payment: this.state?.payment,
              chargeIds: chargeIds,
            },
            onSuccess: () => {
              this.props.dispatch({
                type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
              });

              if (this.state.shouldReplacePath && this.state.nextPath) {
                return this.locationReplace(this.state.nextPath);
              }

              if (this.state.nextPath) {
                return this.redirect(this.state.nextPath);
              }

              return this.initializePage(paymentId);
            },
            onError: () => {
              this.setState(
                {
                  hasModifiedData: true,
                  skipCreateExtraPayment: false,
                  skipCreateAdditionalCharge: false,
                  shouldCreateExtraPayment: false,
                  shouldCreateAdditionalCharge: false,
                  anchorEl: null,
                },
                () => this.initializePage(paymentId)
              );
            },
          });
        },
        onError: () => null,
      });
    });
  };

  public save = (): void => {
    if (
      !this.state.payment?.isReadonly &&
      this.state.paymentDetails?.paymentDataChanged
    ) {
      this.paymentDetails?.current?.updateParentState(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR,
        });

        const payment: any = {
          amount: parseFloat(
            parseFloat(
              String(
                this.formatter.deleteExtraSpace(
                  this.state.paymentDetails?.amountForPayment
                )
              ).replace(',', '.')
            ).toFixed(2)
          ),
          currencyId: this.state.paymentDetails?.currencyIdForPayment,
          firstDateOfStatementPeriod: Time.formatOrNull(
            this.state.paymentDetails?.firstDateOfStatementPeriodForPayment
          ),
          dateOfThePayment: Time.formatOrNull(
            this.state.paymentDetails?.dateOfThePayment
          ),
          paymentTypeId: Number(this.state.paymentDetails?.typeIdForPayment),
          ...this.state.paymentDetails?.baseAccountFields,
          paymentClassId: Number(this.state.paymentDetails?.paymentClassId),
          description: this.state.paymentDetails?.descriptionForPayment,
        };

        if (
          this.state.paymentDetails?.selectedCounterpartyForPayment instanceof
          Person
        ) {
          payment.contactId =
            this.state.paymentDetails?.selectedCounterpartyForPayment?.id;
        }

        if (
          this.state.paymentDetails?.selectedCounterpartyForPayment instanceof
          Company
        ) {
          payment.companyId =
            this.state.paymentDetails?.selectedCounterpartyForPayment?.id;
        }

        this.saving(() => {
          this.props.dispatch({
            type: Constants.GLOBAL_PAYMENT_UPDATE_START,
            payload: {
              paymentId: this.state.payment && this.state.payment.id,
              payment: payment,
            },
            onSuccess: (payment) => {
              if (
                !this.state.chargeChoice ||
                (this.state.chargeChoice === 'existing' &&
                  this.state.chargeIds.length === 0)
              ) {
                if (this.state.nextPath) {
                  return this.redirect(this.state.nextPath);
                }

                return this.initializePage(this.state.payment?.id);
              }

              return this.setState(
                {
                  hasModifiedData: true,
                },
                () => {
                  if (this.state.chargeChoice === 'existing') {
                    return this.linkPaymentWithCharges(
                      payment.id,
                      this.state.chargeIds
                    );
                  }
                }
              );
            },
            onError: () => {
              this.setState(
                {
                  isSaving: false,
                  hasModifiedData: true,
                  anchorEl: null,
                },
                () => this.initializePage(this.state.payment?.id)
              );
            },
          });
        });
      });
    } else {
      if (this.state.chargeIds.length > 0) {
        return this.linkPaymentWithCharges(
          this.state.payment?.id,
          this.state.chargeIds
        );
      }
    }
  };

  public selectDate = (date: Date, identifier: string): void => {
    if (
      !date &&
      (identifier === 'firstDateOfStatementPeriodForPayment' ||
        identifier === 'dateOfThePayment')
    ) {
      return;
    }

    this.setState(
      {
        [identifier]:
          identifier === 'firstDateForCharge' &&
          this.state.periodForCharge === 3 &&
          date
            ? Time.firstDateSelectedMonth(date)
            : date, // todo fix hardcoded value
        hasModifiedData: true,
      },
      () => {
        if (identifier === 'firstDateOfStatementPeriodForPayment') {
          if (
            this.state.firstDateOfStatementPeriodForPayment !== null &&
            this.state.firstDateForCharge !== null
          ) {
            this.setState({
              firstDateForCharge: Time.firstDateSelectedMonth(date),
            });

            return this.selectDate(
              Time.firstDateSelectedMonth(date),
              'firstDateForCharge'
            );
          }
        }

        if (identifier === 'firstDateForCharge') {
          let typeName;

          if (!!this.state.typeIdForCharge) {
            const type = this.getChargeTypeBySelect(this.state.typeIdForCharge);
            typeName = Formatter.checkTranslationType(
              this.trans(type?.label, {}, '', type?.system),
              type?.label,
              type?.system
            );
          }

          this.setModifiedData();
          this.setDescriptionEqualToType(
            typeName,
            Formatter.monthFullFormatDate(date)
          );
        }
      }
    );
  };

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      amountForCharge: amount,
      hasModifiedData: true,
    });
  };

  public changeCurrencyIdForPayment = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForPayment: currency,
      hasModifiedData: true,
    });
  };

  public changeTypeIdForPayment = (event): void => {
    const type = String(event.target.value);

    this.setState({
      typeNameForPayment:
        type == PaymentTypeContainer.pickIdFromLabel('Bank') ? 'Bank' : null,
      typeIdForPayment: type,
      hasModifiedData: true,
    });
  };

  public updateAgencyBankAccountIdForPayment = (event): void => {
    const bankAccountId: number = event.target.value;
    if (bankAccountId) {
      this.setState({
        agencyBankAccountIdForPayment: bankAccountId,
        hasModifiedData: true,
      });
    }
  };

  public changeCounterpartyIbanForPayment = (event): void => {
    const counterpartyIbanForPayment: string = event.target.value;

    this.setState({
      counterpartyIbanForPayment: counterpartyIbanForPayment,
      counterpartyIbanForPaymentWasChanged: true,
      hasModifiedData: true,
    });
  };

  public changePaymentClassId = (event): void => {
    const paymentClassId = String(event.target.value);
    let typeName;

    // change the type to default value when user changes payment class
    if (
      Number(paymentClassId) == PaymentClassContainer.pickIdFromLabel('Payable')
    ) {
      typeName = Formatter.checkTranslationType(
        this.trans(
          this.props.globalTypes?.ChargeType?.[
            TypeContainer.pickIdFromLabel('Other_payable')
          ]?.label
        ),
        this.props.globalTypes?.ChargeType?.[
          TypeContainer.pickIdFromLabel('Other_payable')
        ]?.label
      );
    } else {
      typeName = Formatter.checkTranslationType(
        this.trans(
          this.props.globalTypes?.ChargeType?.[
            TypeContainer.pickIdFromLabel('Other_receivable')
          ]?.label
        ),
        this.props.globalTypes?.ChargeType?.[
          TypeContainer.pickIdFromLabel('Other_receivable')
        ]?.label
      );
    }

    this.setState(
      {
        paymentClassId: paymentClassId,
        chargeClassId: paymentClassId,
        typeIdForCharge:
          Number(paymentClassId) ==
          PaymentClassContainer.pickIdFromLabel('Payable')
            ? TypeContainer.pickIdFromLabel('Other_payable')
            : TypeContainer.pickIdFromLabel('Other_receivable'),
        directIndirectCharges: [],
        selectedDirectIndirectChargesRows: [],
        hasModifiedData: true,
      },
      () => {
        // after changing payment class should fetch charges for list with selected class
        this.fetchExistingCharges();
      }
    );
    this.setDescriptionEqualToType(
      typeName,
      moment(this.state.firstDateForCharge).format('MMMM')
    );
  };

  public changePayerChoice = (event, callback): void => {
    this.clearPersonForPayment();
    this.clearCompanyForPayment();

    const choice: string = event.target.value;
    this.setState(
      {
        payerChoice: choice,
        chargeOwnerChoice: choice,
        selectedPersonForPayment: null,
        selectedCompanyForPayment: null,
        selectedPersonForCharge: null,
        selectedCompanyForCharge: null,
        directIndirectCharges: [],
        selectedDirectIndirectChargesRows: [],
        hasModifiedData: true,
        renderSelectCounterpartyFields: true,
      },
      () => {
        // hack to rerender charge owner choice
        this.setState({ showChargeOwnerChoice: false }, () => {
          this.setState({ showChargeOwnerChoice: true }, () => {
            if (typeof callback === 'function') {
              callback(choice);
            }
          });
        });
      }
    );
  };

  public selectPersonForPayment = (
    person: PersonInterface,
    isManuallySelected: boolean
  ): void => {
    return this.setState(
      {
        selectedPersonForPayment: person,
        selectedPersonForCharge: person,
        hasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.hasModifiedData,
      },
      () => {
        // after changing person should fetch charges for list related to this person
        this.fetchExistingCharges();

        // hack to rerender charge owner choice
        this.setState({ showChargeOwnerChoice: false }, () => {
          this.setState({ showChargeOwnerChoice: true }, () => {
            // need this logic to ask if user wants to update iban for person
            if (
              (!this.state.counterpartyIbanForPayment ||
                (this.state.counterpartyIbanForPayment &&
                  !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
              person &&
              person.mainBankAccountId
            ) {
              return this.setState({
                counterpartyIbanForPayment: person.mainBankAccountId,
                originalCounterpartyIban: person.mainBankAccountId,
                counterpartyIbanForPaymentWasChanged: false,
              });
            }
          });
        });
      }
    );
  };

  public clearPersonForPayment = (): void => {
    const personMainBankAccountId: string =
      this.state.selectedPersonForPayment?.mainBankAccountId;

    return this.setState(
      {
        selectedPersonForPayment: null,
        selectedPersonForCharge: null,
        directIndirectCharges: [],
        selectedDirectIndirectChargesRows: [],
        hasModifiedData: true,
      },
      () => {
        if (personMainBankAccountId === this.state.counterpartyIbanForPayment) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public changePayerChoiceAfterCoach = (event): void => {
    const choice: string = event.target.value;

    this.setState({
      payerChoice: choice,
    });
  };

  public selectCompanyForPayment = (
    company: CompanyInterface,
    isManuallySelected: boolean
  ): void => {
    return this.setState(
      {
        selectedCompanyForPayment: company,
        selectedCompanyForCharge: company,
        hasModifiedData: isManuallySelected
          ? isManuallySelected
          : this.state.hasModifiedData,
      },
      () => {
        // after changing person should fetch charges for list related to this person
        this.fetchExistingCharges();

        // hack to rerender charge owner choice
        this.setState({ showChargeOwnerChoice: false }, () => {
          this.setState({ showChargeOwnerChoice: true }, () => {
            // need this logic to ask if user wants to update iban for person
            if (
              (!this.state.counterpartyIbanForPayment ||
                (this.state.counterpartyIbanForPayment &&
                  !this.state.counterpartyIbanForPaymentIsManuallyChanged)) &&
              company &&
              company.mainBankAccountId
            ) {
              return this.setState({
                counterpartyIbanForPayment: company.mainBankAccountId,
                originalCounterpartyIban: company.mainBankAccountId,
                counterpartyIbanForPaymentWasChanged: false,
              });
            }
          });
        });
      }
    );
  };

  public clearCompanyForPayment = (): void => {
    const companyMainBankAccountId: string =
      this.state.selectedCompanyForPayment?.mainBankAccountId;

    return this.setState(
      {
        selectedCompanyForPayment: null,
        selectedCompanyForCharge: null,
        directIndirectCharges: [],
        selectedDirectIndirectChargesRows: [],
        hasModifiedData: true,
      },
      () => {
        if (
          companyMainBankAccountId === this.state.counterpartyIbanForPayment
        ) {
          return this.setState({
            counterpartyIbanForPayment: '',
            originalCounterpartyIban: '',
            counterpartyIbanForPaymentWasChanged: false,
          });
        }
      }
    );
  };

  public changeDescriptionForPayment = (event): void => {
    const description: string = event.target.value;
    this.setState(
      {
        descriptionForPayment: description,
        hasModifiedData: true,
        descriptionForPaymentIsManuallyChanged: true,
      },
      () => {
        if (!this.state.descriptionForChargeIsManuallyChanged) {
          this.setState({
            descriptionForCharge: description,
          });
        }
      }
    );
  };

  public unlinkCharge = (): void => {
    const charge: ChargeInterface = this.state.chargeToUnlink;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_UNLINK_START,
          payload: {
            charge: charge,
            payment: this.state.payment,
          },
          onSuccess: () => {
            this.initializePage(this.state.payment && this.state.payment.id);
            this.setState({ isSaving: false });
          },
          onError: () => {
            this.setState({
              isChargeUnlinkPopupOpen: false,
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public unrefundCharge = (): void => {
    const charge: ChargeInterface = this.state.chargeToUnrefund;

    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_UNREFUND_START,
          payload: {
            charge: charge,
          },
          onSuccess: () => {
            this.initializePage(this.state.payment && this.state.payment.id);
            this.setState({ isSaving: false });
          },
          onError: () => {
            this.setState({
              isChargeUnlinkPopupOpen: false,
              isSaving: false,
            });
          },
        });
      }
    );
  };

  protected openMenu = (event: any, charge: ChargeInterface): void => {
    this.selectedCharge = charge;

    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null,
    });
  };

  public changeChargeChoiceView = (event): void => {
    const choice: string = event.target.value;

    if (choice === this.state.chargeChoice) {
      return this.setState({
        chargeChoice: '',
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      });
    } else {
      return this.setState(
        {
          chargeChoice: choice,
        },
        () => {
          if (choice === 'existing') {
            this.fetchExistingCharges();
          }

          // if (choice === "new") {
          //   this.setState({
          //     hasModifiedData: true
          //   });
          // }
        }
      );
    }
  };

  // should fetch charges for list related to contact/company or to some object
  public fetchExistingCharges = (firstAutoCall?: boolean): void => {
    const mainPayload: any = {
      chargeClassId: this.state.payment.paymentClass.id,
      isAfterStartDate: 1, // do not fetch charges before start date
      paid: 0,
    };

    // search for charges
    if (!!this.state.chargeSearchString) {
      this.setState(
        {
          chargeSearchInProgress: true,
        },
        () => {
          const payload = {
            ...mainPayload,
            filterValue: this.state.chargeSearchString,
          };

          this.props.dispatch({
            type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
            payload: { ...payload },
            onSuccess: (data) => {
              const filteredCharges = data.charges
                .filter(
                  (charge) =>
                    charge.type.id !==
                    TypeContainer.pickIdFromLabel('Settlement')
                )
                .sort((charge1: ChargeInterface, charge2: ChargeInterface) => {
                  if (charge1.orderDate < charge2.orderDate) {
                    return -1;
                  }

                  if (charge1.orderDate > charge2.orderDate) {
                    return 1;
                  }

                  return 0;
                });

              if (this.state.selectedEntityForExistingCharge instanceof Unit) {
                const payload = {
                  ...mainPayload,
                  propertyId:
                    this.state.selectedEntityForExistingCharge?.propertyId,
                };

                return this.props.dispatch({
                  type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
                  payload: { ...payload },
                  onSuccess: (data) => {
                    const objectCharges = [...data.charges, ...filteredCharges]
                      .filter(
                        (charge) =>
                          charge.type.id !==
                          TypeContainer.pickIdFromLabel('Settlement')
                      )
                      .sort(
                        (
                          charge1: ChargeInterface,
                          charge2: ChargeInterface
                        ) => {
                          if (charge1.orderDate < charge2.orderDate) {
                            return -1;
                          }

                          if (charge1.orderDate > charge2.orderDate) {
                            return 1;
                          }

                          return 0;
                        }
                      );

                    this.setState({
                      objectCharges: objectCharges,
                      chargeSearchInProgress: false,
                    });
                  },
                });
              }

              this.setState({
                objectCharges: filteredCharges,
                chargeSearchInProgress: false,
              });
            },
          });
        }
      );
    } else {
      this.setState({
        objectCharges: [],
        chargeSearchInProgress: false,
      });
    }

    // fetching matched charges
    if (
      !!this.state.payment &&
      firstAutoCall &&
      this.state.payment?.amountRemaining > 0
    ) {
      return this.props.dispatch({
        type: Constants.GLOBAL_GET_MATCHED_CHARGES_LIST,
        payload: {
          paymentId: this.state.payment?.id,
        },
        onSuccess: (charges) => {
          const filteredCharges = charges.filter(
            (charge) =>
              charge?.type?.id !== TypeContainer.pickIdFromLabel('Settlement')
          );
          this.setState(
            {
              directIndirectCharges: filteredCharges,
              showHintBox: true,
              showChargesList: true,
              tabChoice: filteredCharges.length ? 0 : 1,
            },
            () => {
              // CASA-7664

              if (firstAutoCall && this.state.directIndirectCharges.length) {
                this.setState({
                  chargeChoice: 'existing',
                });
              }
            }
          );
        },
      });
    }
  };

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
      return;
    }

    if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isPayable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans('status-still-to-pay')}`;
    } else if (
      0 < charge?.amountRemaining &&
      charge?.amountRemaining < charge?.amount &&
      charge?.isReceivable
    ) {
      status = `${this.formatter.formatNumber(
        charge.amountRemaining,
        charge.currency
      )} ${this.trans('status-still-to-receive')}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isPayable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans('status-to-pay')}`;
    } else if (
      charge?.amountRemaining === charge?.amount &&
      charge?.isReceivable &&
      !charge.isFullyPaid()
    ) {
      status = `${this.trans('status-to-receive')}`;
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans('status-received')}`;
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans('status-amount/paid')}`;
    } else {
      status = '';
    }

    return (
      <span
        style={{
          fontSize: '11px',
          color: '#80808091',
        }}
      >
        {status}
      </span>
    );
  };

  public getCharges = (
    charges: ChargeInterface[],
    selectedChargesRows: number[],
    callback: any
  ): any => {
    return charges.map((charge: ChargeInterface, index: number) => {
      if (!charge) {
        return;
      }

      const shouldShowPaidDate = !!charge.oldestPaymentDate;
      const isItemSelected = selectedChargesRows.includes(index);
      const labelId = `enhanced-table-checkbox-${index}`;

      return (
        <TableRow
          hover
          key={`charge-${charge.id}`}
          onClick={() => {
            this.saveDetailsBeforeRedirect(
              `paymentUpdate-${this.state.payment?.id}-`
            );

            this.redirect(`/app/charge/update/${charge.id}`);
          }}
          role="checkbox"
          aria-checked={isItemSelected}
          selected={isItemSelected}
          className="table-row-cursor"
        >
          <TableCell
            padding="checkbox"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              callback(event, [index]);
            }}
          >
            <Checkbox
              checked={isItemSelected}
              inputProps={{ 'aria-labelledby': labelId }}
              color="primary"
            />
          </TableCell>
          <TableCell
            style={{ width: '24px', paddingLeft: '10px', paddingRight: '5px' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '4px',
              }}
            >
              <div
                style={{ color: charge.getIconColor() }}
                className="icon icon-ic-charge"
              ></div>
            </div>
          </TableCell>
          <TableCell style={{ width: '100px', maxWidth: '100px' }}>
            {shouldShowPaidDate && (
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>{this.formatter.formatDate(charge.orderDate)}</span>
                <span
                  style={{ fontSize: '12px', color: 'gray' }}
                >{`${this.trans(
                  'status-paid'
                ).toLowerCase()}: ${this.formatter.formatDate(
                  charge.oldestPaymentDate
                )}`}</span>
              </div>
            )}
            {!shouldShowPaidDate && (
              <span>{this.formatter.formatDate(charge.orderDate)}</span>
            )}
          </TableCell>
          <TableCell>
            <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {charge?.name || ''}
                {charge.creationTypeDisplayName && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '2px 0px 0px 5px',
                    }}
                  >
                    <div className="list-label creation-type-label">
                      {charge.creationTypeDisplayName}
                    </div>
                  </div>
                )}
              </div>
              <span style={{ fontSize: '12px', color: 'gray' }}>
                {`${
                  charge && charge.description === ''
                    ? Formatter.checkTranslationType(
                        this.trans(
                          charge?.type?.label,
                          {},
                          '',
                          charge?.type?.system
                        ),
                        charge?.type?.label,
                        charge?.type?.system
                      ) +
                      ',' +
                      Formatter.monthFullFormatDate(charge.firstDate)
                    : charge.description
                } ${
                  !!charge.relatedEntity
                    ? '- ' + charge.relatedEntity.displayName
                    : ''
                }`}
              </span>
            </div>
          </TableCell>
          <TableCell style={{ width: '28%', textAlign: 'right' }}>
            {
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>
                  {charge.chargeClass.id ==
                    ChargeClassContainer.pickIdFromLabel('Payable') &&
                    charge?.amount > 0 && (
                      <span className="minus-style">{'-'}</span>
                    )}
                  {this.formatter.formatNumber(charge.amount, charge.currency)}
                </span>
                {this.renderChargeAmountHint(charge)}
              </div>
            }
          </TableCell>
        </TableRow>
      );
    });
  };

  public selectUnselectDirectInDirectCharge = (
    row: number,
    chargeId: number
  ) => {
    if (this.state.selectedDirectIndirectChargesRows.includes(row)) {
      const selectedDirectIndirectChargesRows =
        this.state.selectedDirectIndirectChargesRows.filter(
          (rowId) => rowId !== row
        );
      const chargeIds = this.state.chargeIds.filter((id) => id !== chargeId);

      this.setState({
        selectedObjectChargesRows: [],
        selectedDirectIndirectChargesRows: selectedDirectIndirectChargesRows,
        chargeIds: chargeIds,
      });
    } else {
      const chargesUnpaidAmount: number = this.state.chargeIds
        .map((id) => {
          const charge: ChargeInterface = this.state.directIndirectCharges.find(
            (charge) => charge.id === id
          );
          const amountUnpaid = charge.amountRemaining;

          return amountUnpaid;
        })
        .reduce((a, b) => a + b, 0);
      const paymentUnusedAmount: number = parseFloat(
        (
          100 *
          parseFloat(
            String(
              Formatter.deleteExtraSpace(this.state.amountForPayment)
            ).replace(',', '.')
          )
        ).toFixed(2)
      );

      // we should not allow to select charge if:
      // user already selected chargesPaymentsLinkedLimitNumber charges
      // the sum of unpaid amounts are greater than payment unused amount
      if (chargesUnpaidAmount >= paymentUnusedAmount) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/charge-info/cannottselectchargepaymentfullyused'
            ),
            type: 'warning',
          },
        });
      }

      if (
        this.state.chargeIds.length ===
        this.props.app?.chargesPaymentsLinkedLimitNumber
      ) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/charge-info/cannottselectchargemaxchargenumberselected',
              { number: this.props.app?.chargesPaymentsLinkedLimitNumber }
            ),
            type: 'warning',
          },
        });
      }

      this.setState(
        {
          selectedObjectChargesRows: [],
          selectedDirectIndirectChargesRows: [
            ...this.state.selectedDirectIndirectChargesRows,
            row,
          ],
          chargeIds: [...this.state.chargeIds, chargeId],
        },
        () => {
          if (this.state.chargeIds.length > 0) {
            this.setState({
              hasModifiedData: true,
            });
          }
        }
      );
    }
  };

  public onDirectInDirectChargeRowSelection = (
    _event,
    rows: number[]
  ): void => {
    const row: number = rows[0];
    const chargeId: number = this.state.directIndirectCharges[row].id;

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedObjectChargesRows.length > 0) {
      this.setState(
        {
          selectedObjectChargesRows: [],
          chargeIds: [],
        },
        () => {
          // if user click on selected charge
          this.selectUnselectDirectInDirectCharge(row, chargeId);
        }
      );
    } else {
      this.selectUnselectDirectInDirectCharge(row, chargeId);
    }
  };

  public selectUnselectObjectCharge = (row: number, chargeId: number) => {
    if (this.state.selectedObjectChargesRows.includes(row)) {
      const selectedObjectChargesRows =
        this.state.selectedObjectChargesRows.filter((rowId) => rowId !== row);
      const chargeIds = this.state.chargeIds.filter((id) => id !== chargeId);

      this.setState({
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: selectedObjectChargesRows,
        chargeIds: chargeIds,
        hasModifiedData: true,
      });
    } else {
      const chargesUnpaidAmount: number = this.state.chargeIds
        .map((id) => {
          const charge: ChargeInterface = this.state.objectCharges.find(
            (charge) => charge.id === id
          );
          const amountUnpaid = charge.amountRemaining;

          return amountUnpaid;
        })
        .reduce((a, b) => a + b, 0);
      const paymentUnusedAmount: number = parseFloat(
        (
          100 *
          parseFloat(
            String(
              Formatter.deleteExtraSpace(this.state.amountForPayment)
            ).replace(',', '.')
          )
        ).toFixed(2)
      );

      // we should not allow to select charge if:
      // user already selected chargesPaymentsLinkedLimitNumber charges
      // the sum of unpaid amounts are greater than payment unused amount
      if (chargesUnpaidAmount >= paymentUnusedAmount) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/charge-info/cannottselectchargepaymentfullyused'
            ),
            type: 'warning',
          },
        });
      }

      if (
        this.state.chargeIds.length ===
        this.props.app?.chargesPaymentsLinkedLimitNumber
      ) {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans(
              'section/charge-info/cannottselectchargemaxchargenumberselected',
              { number: this.props.app?.chargesPaymentsLinkedLimitNumber }
            ),
            type: 'warning',
          },
        });
      }

      this.setState(
        {
          selectedDirectIndirectChargesRows: [],
          selectedObjectChargesRows: [
            ...this.state.selectedObjectChargesRows,
            row,
          ],
          chargeIds: [...this.state.chargeIds, chargeId],
        },
        () => {
          if (this.state.chargeIds.length > 0) {
            this.setState({
              hasModifiedData: true,
            });
          }
        }
      );
    }
  };

  public onObjectChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const chargeId: number = this.state.objectCharges[row].id;

    // if there are charges selected in the other list first we should clear them
    if (this.state.selectedDirectIndirectChargesRows.length > 0) {
      this.setState(
        {
          selectedDirectIndirectChargesRows: [],
          chargeIds: [],
        },
        () => {
          // if user click on selected charge
          this.selectUnselectObjectCharge(row, chargeId);
        }
      );
    } else {
      this.selectUnselectObjectCharge(row, chargeId);
    }
  };

  public selectEntityForExistingCharge = (
    entity: PropertyInterface | UnitInterface | ContractInterface
  ): void => {
    this.setState(
      {
        selectedEntityForExistingCharge: entity,
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
      },
      () => {
        // after selecting an object should fetch charges related to this object
        this.fetchExistingCharges();
      }
    );
  };

  public clearEntityForExistingCharge = (): void => {
    this.setState({
      selectedEntityForExistingCharge: null,
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
    });
  };

  public getChargeTypeBySelect = (id) => {
    const chargeType =
      Store.getConfigurator().getState().globalTypes?.ChargeType;
    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  };

  public setDescriptionEqualToType(typeName: string, date: string) {
    if (
      !this.state.descriptionForChargeIsManuallyChanged &&
      !this.state.descriptionForPaymentIsManuallyChanged
    ) {
      if (!!typeName) {
        this.setState({
          descriptionForCharge: typeName + ', ' + date,
        });
      } else {
        this.setState({
          descriptionForCharge: date,
        });
      }
    }
  }

  public changeAmountForCharge = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vatForCharge) {
      let amountForCharge: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;
      let vatPercentageNumber: any = parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.vatPercentageForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      );
      vatPercentageNumber = isNaN(vatPercentageNumber)
        ? 0
        : vatPercentageNumber;

      const vatNumber =
        (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;

      return this.setState({
        vatForCharge: this.formatter.simpleFormatNumber(
          Math.round(vatNumber * 100 + Number.EPSILON) / 100,
          false
        ),
        amountForCharge: amount,
        hasModifiedData: true,
      });
    }

    if (this.state.vatPercentageForCharge) {
      let amountForCharge: number = parseFloat(
        parseFloat(
          String(this.formatter.deleteExtraSpace(amount)).replace(',', '.')
        ).toFixed(2)
      );
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatPercentageNumber: any = parseFloat(
        parseFloat(
          String(
            this.formatter.deleteExtraSpace(this.state.vatPercentageForCharge)
          ).replace(',', '.')
        ).toFixed(2)
      );
      vatPercentageNumber = isNaN(vatPercentageNumber)
        ? 0
        : vatPercentageNumber;

      const vatNumber =
        (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;
      return this.setState({
        vatForCharge: this.formatter.simpleFormatNumber(
          Math.round(vatNumber * 100 + Number.EPSILON) / 100,
          false
        ),
        amountForCharge: amount,
        hasModifiedData: true,
      });
    }

    return this.setState({
      vatForCharge: '',
      vatPercentageForCharge: '',
      amountForCharge: amount,
      hasModifiedData: true,
    });
  };

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForCharge: currency,
      hasModifiedData: true,
    });
  };

  public changeVatForCharge = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let amountForCharge: number = parseFloat(
      parseFloat(
        String(
          this.formatter.deleteExtraSpace(this.state.amountForCharge)
        ).replace(',', '.')
      ).toFixed(2)
    );
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatNumber: any = parseFloat(
      parseFloat(
        String(this.formatter.deleteExtraSpace(vat)).replace(',', '.')
      ).toFixed(2)
    );
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber =
      (vatNumber / (amountForCharge - vatNumber)) * 100;

    this.setState({
      vatForCharge: vat,
      vatPercentageForCharge: isNaN(vatPercentageNumber)
        ? 0
        : this.formatter.simpleFormatNumber(
            Math.round(vatPercentageNumber),
            false,
            false
          ),
      hasModifiedData: true,
    });
  };

  public changeVatPercentageForCharge = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let amountForCharge: number = parseFloat(
      parseFloat(
        String(
          this.formatter.deleteExtraSpace(this.state.amountForCharge)
        ).replace(',', '.')
      ).toFixed(2)
    );
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatPercentageNumber: any = parseFloat(
      parseFloat(
        String(this.formatter.deleteExtraSpace(vatPercentage)).replace(',', '.')
      ).toFixed(2)
    );
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber =
      (amountForCharge / (100 + vatPercentageNumber)) * vatPercentageNumber;

    this.setState({
      vatForCharge: this.formatter.simpleFormatNumber(
        Math.round(vatNumber * 100 + Number.EPSILON) / 100,
        false
      ),
      vatPercentageForCharge: vatPercentage,
      hasModifiedData: true,
    });
  };

  public changeChargeOwnerChoice = (event, callback): void => {
    const choice: string = event.target.value;

    this.setState(
      {
        chargeOwnerChoice: choice,
        selectedPersonForCharge: null,
        selectedCompanyForCharge: null,
      },
      () => {
        if (typeof callback === 'function') {
          callback(choice);
        }
      }
    );
  };

  public selectPersonForCharge = (
    person: PersonInterface,
    isManuallySelected: boolean
  ): void => {
    this.setState({
      selectedPersonForCharge: person,
      hasModifiedData: isManuallySelected
        ? isManuallySelected
        : this.state.hasModifiedData,
    });
  };

  public clearPersonForCharge = (): void => {
    this.setState({
      selectedPersonForCharge: null,
      hasModifiedData: true,
    });
  };

  public selectCompanyForCharge = (
    company: CompanyInterface,
    isManuallySelected: boolean
  ): void => {
    this.setState({
      selectedCompanyForCharge: company,
      hasModifiedData: isManuallySelected
        ? isManuallySelected
        : this.state.hasModifiedData,
    });
  };

  public clearCompanyForCharge = (): void => {
    this.setState({
      selectedCompanyForCharge: null,
      hasModifiedData: true,
    });
  };

  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);
      const typeName = Formatter.checkTranslationType(
        this.trans(type?.label, {}, '', type?.system),
        type?.label,
        type?.system
      );
      const chargeClassId: number =
        this.props.globalTypes?.ChargeType?.[type?.id]?.chargeClassId;

      this.setState({
        typeIdForCharge: type.id,
        hasModifiedData: true,
        typeIdForChargeManuallyChanged: true,
        chargeClassId: chargeClassId,
      });

      this.setDescriptionEqualToType(
        typeName,
        Formatter.monthFullFormatDate(this.state.firstDateForCharge)
      );
    }
  };

  public changeTypeIdForCostsCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);

      this.setState({
        typeIdForCostsCharge: type.id,
      });
    }
  };

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType,
        },
        onSuccess: (chargeType) => {
          this.setState({
            isSaving: false,
            typeIdForCharge: chargeType.id,
            isCreateChargeTypePopupOpen: false,
            hasModifiedData: true,
          });

          this.setDescriptionEqualToType(
            chargeType.label,
            this.formatter.monthFullFormatDate(this.state.firstDateForCharge)
          );

          if (typeof callback === 'function') {
            callback();
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false,
          });
        },
      });
    });
  };

  public getStatementPeriodForCharge = () => {
    const payload: any = {
      statementPeriod: Time.formatOrNull(this.state.firstDateForCharge),
    };

    if (this.state.selectedEntityForCharge instanceof Property) {
      payload.propertyId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Unit) {
      payload.unitId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Contract) {
      payload.contractId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Company) {
      payload.ownerId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Event) {
      payload.eventId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedPersonForCharge?.id) {
      payload.contactId = this.state.selectedPersonForCharge?.id;
    }

    if (this.state.selectedCompanyForCharge?.id) {
      payload.companyId = this.state.selectedCompanyForCharge?.id;
    }

    return this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_PERIOD,
      payload: {
        ...payload,
      },
      onSuccess: (data) => {
        if (data?.statementPeriod) {
          this.selectDate(
            new Date(data?.statementPeriod),
            'firstDateForCharge'
          );
        }
      },
    });
  };

  public selectEntityForNewCharge = (
    entity: PropertyInterface | UnitInterface | ContractInterface
  ): void => {
    this.setState(
      {
        selectedEntityForNewCharge: entity,
        selectedEntityForNewChargeManuallyChanged: true,
        hasModifiedData: true,
      },
      this.getStatementPeriodForCharge
    );
  };

  public clearEntityForNewCharge = (): void => {
    this.setState({
      selectedEntityForNewCharge: null,
      selectedEntityForNewChargeManuallyChanged: true,
      hasModifiedData: true,
    });
  };

  public selectEntityForCharge = (
    entity: PropertyInterface | UnitInterface | ContractInterface
  ): void => {
    this.setState(
      {
        selectedEntityForCharge: entity,
        selectedEntityForChargeManuallyChanged: true,
        hasModifiedData: true,
      },
      this.getStatementPeriodForCharge
    );
  };

  public clearEntityForCharge = (): void => {
    this.setState({
      selectedEntityForCharge: null,
      selectedEntityForChargeManuallyChanged: true,
      hasModifiedData: true,
    });
  };

  public changePeriodForCharge = (event): void => {
    let period: number = event.target.value;

    this.setState({
      periodForCharge: period,
      hasModifiedData: true,
    });
  };

  public changeDescriptionForCharge = (event): void => {
    const description: string = event.target.value;

    this.setState({
      descriptionForCharge: description,
      hasModifiedData: true,
      descriptionForChargeIsManuallyChanged: true,
    });
  };

  // * START * Payment 3-dots menu methods

  protected openPaymentMenu = (event: any): void => {
    this.setState({
      anchorPaymentEl: event.currentTarget,
    });
  };

  protected closePaymentMenu = (): void => {
    this.setState({
      anchorPaymentEl: null,
    });
  };

  public closePaymentPrompt = (): void => {
    this.setState({
      isPaymentRemovePopupOpen: false,
      isPaymentUnlinkPopupOpen: false,
      isPaymentUnSettlePopupOpen: false,
    });
  };

  public closeDialog = () => {
    this.setState({
      isPaymentCheckToSettle: false,
    });
  };

  public unSettlePayment = (): any => {
    this.setState({
      isSaving: true,
      isPaymentUnSettlePopupOpen: false,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNSETTLE_START,
      payload: {
        payment: this.state.payment,
      },
      onSuccess: () => {
        const id = parseInt(this.props.params.id, 10);

        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR,
        });

        this.initializePage(id);
        this.setState({ isPaymentUnSettlePopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isPaymentUnSettlePopupOpen: false,
          isSaving: false,
        });
      },
    });
  };

  public unlinkPayment = (): any => {
    this.setState({
      isSaving: true,
      isPaymentUnlinkPopupOpen: false,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNLINK_START,
      payload: {
        payment: this.state.payment,
      },
      onSuccess: () => {
        const id = parseInt(this.props.params.id, 10);

        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR,
        });

        this.initializePage(id);
        this.setState({ isPaymentUnlinkPopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isPaymentUnlinkPopupOpen: false,
          isSaving: false,
        });
      },
    });
  };

  public deletePayment = () => {
    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_DELETE_START,
      payload: {
        payment: this.state.payment,
      },
      onSuccess: () => {
        this.setState(
          {
            isSaving: false,
            isPaymentRemovePopupOpen: false,
          },
          this.redirectBack
        );
      },
      onError: () => {
        this.setState({
          isSaving: false,
          isPaymentRemovePopupOpen: false,
        });
      },
    });
  };

  public settleWithSavingsCheckScenario = () => {
    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START,
      payload: {
        paymentId: this.state?.payment?.id,
      },
      onSuccess: (scenario) => {
        if (typeof scenario === 'string') {
          this.setState({
            isPaymentSettleWithSavingsPopupOpen: true,
            settleSavingScenarioMessage: scenario,
          });
        }
        this.setState({
          isSaving: false,
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          settleSavingScenarioMessage:
            'it_is_not_possible_to_make_savings_action',
        });
      },
    });
  };

  public changePaymentProcessed = () => {
    this.saving(() => {
      // if (this.state.payment?.transactionFileId) {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_SET_PROCESSED_START,
        payload: {
          // transactionFileId: this.state.payment?.transactionFileId,
          paymentId: this.state?.payment?.id,
          verified: this.state.isProcessed,
        },
        onSuccess: () => {
          this.setState(
            {
              isSaving: false,
            },
            () => {
              this.props.dispatch({
                type: Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE,
                payload: {
                  paymentId: this.state?.payment?.id,
                },
                onSuccess: (payment: PaymentInterface) => {
                  this.setState(
                    {
                      payment: payment,
                      hasModifiedData: false,
                      isProcessed: payment?.isProcessed,
                    },
                    this.initializePage.bind(this, payment?.id)
                  );
                },
              });
            }
          );
        },
        onError: () => {
          this.setState({
            isProcessed: !this.state.isProcessed,
            isSaving: false,
            hasModifiedData: true,
          });
        },
      });
      // } else {
      //   this.props.dispatch({
      //     type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START,
      //       payload: {
      //         paymentId: this.state.payment && this.state.payment.id,
      //         payment: {isProcessed: this.state.isProcessed}
      //       },
      //     onSuccess: () => {
      //       this.setState({
      //         isSaving: false
      //       }, () => {
      //         this.props.dispatch({
      //           type: Constants.GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE,
      //           payload: {
      //             paymentId: this.state?.payment?.id
      //           },
      //           onSuccess: (payment: PaymentInterface) => {
      //             this.setState({
      //               payment: payment,
      //               hasModifiedData: false,
      //               isProcessed: payment?.isProcessed
      //             }, this.initializePage.bind(this, payment?.id));
      //           }
      //         })
      //       })
      //     },
      //     onError: () => {
      //       this.setState({
      //         isProcessed: !this.state.isProcessed,
      //         isSaving: false,
      //         hasModifiedData: true
      //       });
      //     }
      //   });
      // }
    });
  };

  public openMemoPopup = (payment: PaymentInterface) => {
    this.setState({
      paymentToAddNote: payment,
      note: payment?.note,
      memoPopupOpen: true,
      anchorEl: null,
    });
  };
  public saveDraft = (message) => {
    this.setState({
      note: message,
    });
  };

  public saveReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: { note: this.state.note },
          updateMemo: true,
        },
        onSuccess: (payment) => {
          this.setState({
            isSaving: false,
            memoPopupOpen: false,
            payment: payment,
          });
        },
        onError: () => {
          this.setState({ isSaving: false });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans('memo-can-not-be-updated'),
              type: 'warning',
            },
          });
        },
      });
    });
  };

  public removeReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: { note: '' },
          removeMemo: true,
        },
        onSuccess: (payment) => {
          this.setState({
            isSaving: false,
            memoPopupOpen: false,
            payment: payment,
          });
        },
        onError: () => {
          this.setState({ isSaving: false });
        },
      });
    });
  };

  public onDirectIndirectPaymentRowSelection = (
    _event,
    rows: number[]
  ): void => {
    let payments: PaymentInterface[];
    let paymentsIds: number[];
    let payment = null;

    payments = rows.map((row) => {
      return this.state.directIndirectPayments[row];
    });

    paymentsIds = rows.map((row) => {
      return this.state.directIndirectPayments[row].id;
    });

    if (!!payments && payments.length > 0) {
      payment = payments[0];
    }

    // if there are payments selected in the other list first we should clear them
    if (this.state.selectedPayerPaymentsRows.length > 0) {
      this.setState(
        {
          selectedPayerPaymentsRows: [],
          paymentIds: [],
        },
        () => {
          // if user click on selected payment
          // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
          if (this.state.selectedDirectIndirectPaymentsRows[0] === rows[0]) {
            this.setState({
              selectedDirectIndirectPaymentsRows: [],
              paymentIds: [],
              selectedPayment: null,
            });
          } else {
            this.setState({
              selectedDirectIndirectPaymentsRows: rows,
              paymentIds: paymentsIds,
              selectedPayment: payment,
            });
          }
        }
      );
    } else {
      if (this.state.selectedDirectIndirectPaymentsRows[0] === rows[0]) {
        this.setState({
          selectedDirectIndirectPaymentsRows: [],
          paymentIds: [],
          selectedPayment: null,
        });
      } else {
        this.setState({
          selectedDirectIndirectPaymentsRows: rows,
          paymentIds: paymentsIds,
          selectedPayment: payment,
        });
      }
    }
  };

  public onPayerPaymentRowSelection = (_event, rows: number[]): void => {
    let payments: PaymentInterface[];
    let paymentsIds: number[];
    let payment = null;

    payments = rows.map((row) => {
      return this.state.payerPayments[row];
    });

    paymentsIds = rows.map((row) => {
      return this.state.payerPayments[row].id;
    });

    if (!!payments && payments.length > 0) {
      payment = payments[0];
    }

    // if there are payments selected in the other list first we should clear them
    if (this.state.selectedDirectIndirectPaymentsRows.length > 0) {
      this.setState(
        {
          selectedDirectIndirectPaymentsRows: [],
          paymentIds: [],
        },
        () => {
          // if user click on selected payment
          // if selectRows === rows in our state, we clear this field(unselect), otherwise we set selected row.
          if (this.state.selectedPayerPaymentsRows[0] === rows[0]) {
            this.setState({
              selectedPayerPaymentsRows: [],
              paymentIds: [],
              selectedPayment: null,
            });
          } else {
            this.setState({
              selectedPayerPaymentsRows: rows,
              paymentIds: paymentsIds,
              selectedPayment: payment,
            });
          }
        }
      );
    } else {
      if (this.state.selectedPayerPaymentsRows[0] === rows[0]) {
        this.setState({
          selectedPayerPaymentsRows: [],
          chargeIds: [],
          selectedCharge: null,
        });
      } else {
        this.setState({
          selectedPayerPaymentsRows: rows,
          paymentIds: paymentsIds,
          selectedPayment: payment,
        });
      }
    }
  };

  public settleWithPayment = (selectedPayment: PaymentInterface) => {
    this.setState(
      {
        isSaving: true,
      },
      () => {
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_SETTLE_START,
          payload: {
            id: this.state.payment?.id,
            paymentId: selectedPayment.id,
          },
          onSuccess: () => {
            this.setState(
              {
                isSaving: false,
                hasModifiedData: false,
                isSettlePaymentPopupOpen: false,
                directIndirectPayments: [],
                payerPayments: [],
                selectedDirectIndirectPaymentsRows: [],
                selectedPayerPaymentsRows: [],
                paymentSearchString: '',
              },
              () => {
                this.props.dispatch({
                  type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
                });

                if (this.state.nextPath) {
                  return this.redirect(this.state.nextPath);
                }

                this.initializePage(this.state.payment?.id);
              }
            );
          },
          onError: () => {
            this.setState({
              hasModifiedData: true,
              isSaving: false,
            });
          },
        });
      }
    );
  };

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: '11px',
          color: '#80808091',
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  };

  public handleSettleChargeSelection = (state) => {
    if (typeof state === 'object' && state !== null) {
      this.setState({
        selectedSecondChargeToSettleId: Object.values(state)[0]
          ? Object.values(state)
          : [],
        hasModifiedData: state?.selectedSecondChargeToSettleId ? true : false,
      });
    }
  };

  public getPayments = (
    payments: PaymentInterface[],
    selectedPaymentsRows: number[],
    callback: any
  ): any => {
    return payments
      .filter((payment) => !!payment)
      .map((payment: PaymentInterface, index: number) => {
        let color = '#43A047';

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = '#F44336';
          } else {
            color = '#F5A623';
          }
        }

        if (!payment) {
          return;
        }
        const isItemSelected = selectedPaymentsRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`payment-${payment.id}`}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                callback(event, [index]);
              }}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell
              style={{
                width: '24px',
                paddingLeft: '10px',
                paddingRight: '5px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: '4px',
                }}
              >
                <div
                  className="icon icon-ic-payment"
                  style={{ color: color }}
                ></div>
              </div>
            </TableCell>
            <TableCell style={{ width: '20%' }}>
              {this.formatter.formatDate(payment.dateOfThePayment)}
            </TableCell>
            <TableCell style={{ width: '40%' }}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell>
              {payment.creationTypeDisplayName && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="list-label creation-type-label">
                    {payment.creationTypeDisplayName}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell style={{ textAlign: 'right', width: '40%' }}>
              <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                <span>
                  {payment.paymentClass.id ==
                    PaymentClassContainer.pickIdFromLabel('Payable') && (
                    <span className="minus-style">{'-'}</span>
                  )}
                  {this.formatter.formatNumber(
                    payment.amount,
                    payment.currency
                  )}
                </span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
          </TableRow>
        );
      });
  };

  public switchTab = (_event, tabValue) => {
    if (tabValue === 0) {
      this.fetchExistingCharges(true);
      this.setState({
        showChargesList: true,
        tabChoice: tabValue,
      });
    }
    if (tabValue === 1) {
      this.setState({
        showChargesList: true,
        directIndirectCharges: [],
        tabChoice: tabValue,
      });
    }
    if (tabValue === 2) {
      this.setState({
        isCoachNewChargeOpen: true,
        anchorPaymentEl: null,
        tabChoice: tabValue,
      });
    }
  };

  public render() {
    // const isLocked = this.state.payment && this.state.payment.isLocked !== undefined ? this.state.payment.isLocked : false;
    // const isRefunded = this.state.payment && this.state.payment.isRefunded !== undefined ? this.state.payment.isRefunded : false;
    const isRemoved =
      this.state.payment && this.state.payment.removed !== undefined
        ? this.state.payment.removed
        : false;
    const agencyMainBankAccountId = this.getAgency()?.agencyBankAccountId;
    let showHintPanel;
    if (
      agencyMainBankAccountId === this.state.payment?.mainBankAccountId &&
      this.state.payment?.paymentClass.id ==
        PaymentClassContainer.pickIdFromLabel('Payable')
    ) {
      showHintPanel = true;
    }

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button align-center">
            <div
              className="inner-wrapper"
              style={{ justifyContent: 'space-between' }}
            >
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div
                className="title-wrapper"
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <h1>{this.trans('page/paymentupdate-title')}</h1>
              </div>
              <div className="button-container">
                {this.state.payment?.hasTransaction && (
                  <div>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.isProcessed}
                          onChange={() => {
                            this.setState(
                              {
                                isProcessed: !this.state.isProcessed,
                              },
                              this.changePaymentProcessed
                            );
                          }}
                          color="primary"
                          disabled={isRemoved}
                        />
                      }
                      label={this.trans('status-verified')}
                    />
                  </div>
                )}

                {this.props.app?.nextTransactionPayments.length > 0 &&
                  this.props.app?.transactionPaymentIndex !== 0 && (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        const transactionPayments =
                          this.props.app?.nextTransactionPayments || [];
                        const currentPaymentIndex =
                          this.props.app?.transactionPaymentIndex;
                        const previousPayment =
                          transactionPayments[currentPaymentIndex - 1];

                        if (previousPayment) {
                          this.props.dispatch({
                            type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
                            payload: {
                              payments: [...transactionPayments],
                              index: currentPaymentIndex - 1,
                            },
                          });
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorPaymentEl: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.setState(
                              {
                                shouldReplacePath: true,
                                // isSaving: true,
                                hasModifiedData: false,
                              },
                              () =>
                                this.locationReplace(
                                  `/app/payment/update/${previousPayment?.id}`
                                )
                            );

                            window.scrollTo(0, 0);
                          }
                        } else {
                          this.redirectBack();
                        }
                      }}
                      style={{ marginRight: '20px' }}
                    >
                      <div
                        className="icon icon-ic-keyboard-arrow-left blue-onhover"
                        style={{
                          fill: 'rgb(117, 117, 117)',
                          color: 'rgb(117, 117, 117)',
                          position: 'relative' as 'relative',
                          marginTop: '5px',
                        }}
                      ></div>
                    </Button>
                  )}
                {this.props.app?.transactionPaymentIndex !==
                  this.props.app?.nextTransactionPayments.length - 1 &&
                  this.props.app?.nextTransactionPayments.length > 0 && (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        const nextTransactionPayments =
                          this.props.app?.nextTransactionPayments || [];
                        const nextTransactionPaymentIndex =
                          this.props.app?.transactionPaymentIndex;
                        const nextPayment =
                          nextTransactionPayments[
                            nextTransactionPaymentIndex + 1
                          ];

                        if (nextPayment) {
                          this.props.dispatch({
                            type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
                            payload: {
                              payments: [...nextTransactionPayments],
                              index: nextTransactionPaymentIndex + 1,
                            },
                          });
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorPaymentEl: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.setState(
                              {
                                shouldReplacePath: true,
                                // isSaving: true,
                                hasModifiedData: false,
                              },
                              () =>
                                this.locationReplace(
                                  `/app/payment/update/${nextPayment?.id}`
                                )
                            );

                            window.scrollTo(0, 0);
                          }
                        } else {
                          this.redirectBack();
                        }
                      }}
                      style={{ marginRight: '20px' }}
                    >
                      <div
                        className="icon icon-ic-keyboard-arrow-right blue-onhover"
                        style={{
                          fill: 'rgb(117, 117, 117)',
                          color: 'rgb(117, 117, 117)',
                          position: 'relative' as 'relative',
                          marginTop: '5px',
                        }}
                      ></div>
                    </Button>
                  )}
                {this.hasModifiedData() && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.save.bind(this)}
                    style={{ marginRight: '20px' }}
                  >
                    {this.trans('page/entity-button/save')}
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.redirectBack}
                  disabled={this.state.isSaving}
                >
                  {this.trans('button-close')}
                </Button>
              </div>
            </div>
          </div>

          <div>
            <div className="box component-payment-update">
              {this.state.renderDetails && (
                <>
                  {
                    // this.state.showHintBox &&
                    this.state.payment &&
                      this.state.payment?.hasTransaction &&
                      !this.state.isProcessed &&
                      this.state.linkedCharges?.length > 0 &&
                      this.state.linkedCharges?.some(
                        (charge: ChargeInterface) => charge?.automaticallyLinked
                      ) && (
                        <div className="component-wrapper no-margin-top">
                          <Card
                            className="card"
                            style={{
                              padding: '20px',
                              backgroundColor: '#ffe0b3',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <div className="icon icon-ic-info"></div>
                                <div style={{ marginLeft: '12px' }}>
                                  {this.trans('page/paymentupdate/question1')}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  marginTop: '8px',
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={this.unlinkPayment}
                                >
                                  {this.trans('label-no')}
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ marginLeft: '12px' }}
                                  onClick={() => {
                                    this.setState(
                                      {
                                        isProcessed: true,
                                      },
                                      this.changePaymentProcessed
                                    );
                                  }}
                                >
                                  {this.trans('label-yes')}
                                </Button>
                              </div>
                            </div>
                          </Card>
                        </div>
                      )
                  }
                  <div className="component-wrapper no-margin-top">
                    <div
                      className="component"
                      style={{ position: 'relative' as 'relative' }}
                    >
                      {this.state.isFetchingPayment ? (
                        <div style={{ position: 'relative', height: '60px' }}>
                          <div className="component-spinner-wrapper">
                            <CircularProgress />
                          </div>
                        </div>
                      ) : (
                        <Payment2Card
                          {...this.props}
                          payment={this.state.payment}
                          mainCardPresentation={true}
                          isSummaryView={this.state.showPaymentCardSummaryView}
                          initializePage={() => {
                            this.initializePage(this.state.payment?.id);
                          }}
                          toggleSummaryView={() =>
                            this.setState({
                              showPaymentCardSummaryView:
                                !this.state.showPaymentCardSummaryView,
                            })
                          }
                          refPaymentDetails={this.paymentDetails}
                          updateState={(paymentDetailsState, callback?) => {
                            this.setState(
                              {
                                paymentDetails: {
                                  ...paymentDetailsState,
                                },
                                ...paymentDetailsState,
                              },
                              () => {
                                if (typeof callback === 'function') {
                                  callback();
                                }
                              }
                            );
                          }}
                          updateFullState={(paymentDetailsState: PaymentInterface, callback?) => {
                            this.setState(
                              {
                                payment: paymentDetailsState,
                                ...paymentDetailsState,
                              },
                              () => {
                                if (typeof callback === 'function') {
                                  callback();
                                }
                              }
                            );
                          }}
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
              {this.state.renderDetails &&
                !this.state.isFetchingPayment &&
                showHintPanel &&
                this.state.payment?.amountUsed === 0 && (
                  <div className="component-wrapper no-margin-top">
                    <Card
                      className="card"
                      style={{ padding: '20px', backgroundColor: '#FDFFEC' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="icon icon-ic-info"></div>
                        <div style={{ marginLeft: '12px' }}>
                          {this.trans('payment-details-hint', {
                            agencyName: this.getAgency()?.name,
                          })}
                        </div>
                      </div>
                    </Card>
                  </div>
                )}

              <div style={{ padding: '0 30px' }}>
                {this.state.payment &&
                  this.state.relatedCharges &&
                  this.state.relatedCharges?.filter(
                    (charge: ChargeInterface) => !charge.hasSettlementType
                  ).length > 0 && (
                    <div className="link-info">
                      <div>|</div>
                      <div>
                        {this.trans('page/paymentchargeupdate-label/relatedto')}
                      </div>
                      <div>|</div>
                    </div>
                  )}

                {this.state.relatedCharges?.length > 0 &&
                  this.state.relatedCharges
                    ?.filter(
                      (charge: ChargeInterface) => !charge.hasSettlementType
                    )
                    .map((charge: ChargeInterface) => {
                      return (
                        <div className="component-wrapper">
                          <div className="component">
                            <Charge2Card
                              {...this.props}
                              key={`charge-${charge?.id}`}
                              charge={charge}
                              linkedPayment={this.state.payment}
                              showAmountUsed={true}
                              // paymentIdForDetailsPresentation={this.state.paymentIdForDetailsPresentation}
                              // changeSettledIdForDetailsPresentation={id => this.setState({settledChargeIdForDetailsPresentation: id})}
                              // changePaymentIdForDetailsPresentation={id => this.setState({paymentIdForDetailsPresentation: id})}
                              unActionButton={
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: '#F44336',
                                    borderColor: '#F44336',
                                  }}
                                  onClick={() => {
                                    if (
                                      this.checkProcessIsBusy({
                                        action: 'unlink',
                                        entityName: 'payment',
                                        entity: this.state.payment,
                                      })
                                    ) {
                                      this.openIsBusyPopup();
                                      this.setState({ anchorEl: null });
                                    } else {
                                      this.setState({
                                        isChargeUnrefundPopupOpen: true,
                                        chargeToUnrefund: charge,
                                        anchorEl: null,
                                      });
                                    }
                                  }}
                                >
                                  {this.trans('menu/payment-option/unrefund')}
                                </Button>
                              }
                              isSummaryView={
                                !(
                                  this.state.payment?.hasTransaction &&
                                  !this.state.isProcessed
                                )
                              }
                            />
                          </div>
                        </div>
                      );
                    })}

                {this.state.payment &&
                  this.state.linkedCharges &&
                  this.state.linkedCharges?.filter(
                    (charge: ChargeInterface) => !charge.hasSettlementType
                  ).length > 0 && (
                    <div className="link-info">
                      <div>|</div>
                      <div>
                        {this.trans('page/paymentupdate-label/paidfor')}
                      </div>
                      <div>|</div>
                    </div>
                  )}

                {/* {
                  this.state.payment?.hasTransaction && 
                  !this.state.isProcessed && 
                  this.state.linkedCharges?.length > 0 && 
                  this.state.linkedCharges?.some((charge: ChargeInterface) => charge?.automaticallyLinked) &&
                  <div className="component-wrapper">
                      <div className="component">
                        <div style={{padding: "10px", backgroundColor: "white"}}>
                          {this.trans("page/paymentupdate-hint/transactionautomaticallylinked")}
                        </div>
                      </div>
                  </div>
                } */}

                {this.state.linkedCharges?.length > 0 &&
                  this.state.linkedCharges
                    ?.filter(
                      (charge: ChargeInterface) =>
                        !charge.hasSettlementType &&
                        !charge.isReferencedToSavings
                    )
                    .map((charge: ChargeInterface) => {
                      const settlementAmount =
                        charge.paymentDetails[this.state.payment.id];
                      return (
                        <div className="component-wrapper">
                          <div className="component">
                            <Charge2Card
                              {...this.props}
                              key={`charge-${charge?.id}`}
                              charge={charge}
                              linkedPayment={this.state.payment}
                              // showAmountUsed={true}
                              settlementAmount={settlementAmount}
                              isSettled={true}
                              // paymentIdForDetailsPresentation={this.state.paymentIdForDetailsPresentation}
                              // changeSettledIdForDetailsPresentation={id => this.setState({settledChargeIdForDetailsPresentation: id})}
                              // changePaymentIdForDetailsPresentation={id => this.setState({paymentIdForDetailsPresentation: id})}
                              unActionButton={
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: '#F44336',
                                    borderColor: '#F44336',
                                  }}
                                  onClick={() => {
                                    if (
                                      this.checkProcessIsBusy({
                                        action: 'unlink',
                                        entityName: 'payment',
                                        entity: this.state.payment,
                                      })
                                    ) {
                                      this.openIsBusyPopup();
                                      this.setState({ anchorEl: null });
                                    } else {
                                      this.setState({
                                        isChargeUnlinkPopupOpen: true,
                                        anchorEl: null,
                                      });
                                    }
                                  }}
                                >
                                  {this.trans('button-unlink')}
                                </Button>
                              }
                            />
                          </div>
                        </div>
                      );
                    })}

                {this.state.linkedCharges?.length > 0 &&
                  this.state.linkedCharges
                    ?.filter(
                      (charge: ChargeInterface) =>
                        charge.isReferencedToSavings &&
                        !charge.hasSettlementType
                    )
                    .map((charge: ChargeInterface) => {
                      return (
                        <div className="component-wrapper">
                          <div className="component">
                            <Charge2Card
                              {...this.props}
                              key={`charge-${charge?.id}`}
                              charge={charge}
                              linkedPayment={this.state.payment}
                              showAmountUsed={true}
                              unActionButton={
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: '#F44336',
                                    borderColor: '#F44336',
                                  }}
                                  onClick={() => {
                                    if (
                                      this.checkProcessIsBusy({
                                        action: 'unsettle',
                                        entityName: 'charge',
                                        entity: charge,
                                      })
                                    ) {
                                      this.openIsBusyPopup();
                                      this.setState({ anchorEl: null });
                                    } else {
                                      this.setState({
                                        isUndoSavingsPopupOpen: true,
                                        anchorEl: null,
                                        entityToUnsettleWithSavings: charge,
                                      });
                                    }
                                  }}
                                >
                                  {this.trans('button-unsettle')}
                                </Button>
                              }
                            />
                          </div>
                        </div>
                      );
                    })}

                {this.state.settledPayments?.length > 0 && (
                  <div className="link-info">
                    <div>|</div>
                    <div>
                      {this.trans('page/chargeupdate-label/settledwith')}
                    </div>
                    <div>|</div>
                  </div>
                )}

                {this.state.settledPayments?.reverse()?.map((paymentData) => {
                  return (
                    <div className="component-wrapper">
                      <div className="component">
                        <Payment2Card
                          {...this.props}
                          key={`payment-${paymentData?.payment?.id}`}
                          payment={paymentData?.payment}
                          isSettled={true}
                          // settledPaymentIdForDetailsPresentation={this.state.settledPaymentIdForDetailsPresentation}
                          // changeSettledIdForDetailsPresentation={id => this.setState({settledPaymentIdForDetailsPresentation: id})}
                          // changeChargeIdForDetailsPresentation={id => this.setState({chargeIdForDetailsPresentation: id})}
                          unActionButton={
                            <Button
                              variant="outlined"
                              style={{
                                color: '#F44336',
                                borderColor: '#F44336',
                              }}
                              onClick={() => {
                                if (
                                  this.checkProcessIsBusy({
                                    action: 'unsettle',
                                    entityName: 'payment',
                                    entity: this.state.payment,
                                  })
                                ) {
                                  this.openIsBusyPopup();
                                } else {
                                  if (paymentData?.payment?.hasSavingsType) {
                                    this.setState({
                                      isUndoSavingsPopupOpen: true,
                                    });
                                  } else {
                                    this.setState({
                                      isPaymentUnSettlePopupOpen: true,
                                    });
                                  }
                                }
                              }}
                            >
                              {this.trans('button-unsettle')}
                            </Button>
                          }
                        />
                      </div>
                    </div>
                  );
                })}

                {/* {
                  this.state.showHintBox && this.state.payment && !this.state.directIndirectCharges.length && this.state.payment?.amountRemaining > 0 &&
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{padding: "20px", backgroundColor: "#FDFFEC"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div className="icon icon-ic-info"></div>
                          <div style={{marginLeft: "12px"}}>
                            {this.trans("page/paymentupdate/tab/find-charge/panel-title")}
                          </div>
                        </div>
                      </Card>
                    </div>
                  } */}
                {/* {
                  this.state.showHintBox && this.state.payment && this.state.directIndirectCharges.length > 0 && this.state.payment?.amountRemaining > 0 &&
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{padding: "20px", backgroundColor: "#FDFFEC"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div className="icon icon-ic-info"></div>
                          <div style={{marginLeft: "12px"}}>
                            {this.trans("page/paymentupdate/tab/select-charge/panel-title")}
                          </div>
                        </div>
                      </Card>
                    </div>
                  } */}

                {
                  // this.state.showHintBox &&
                  this.state.payment &&
                    this.state.payment?.amountRemaining > 0 && (
                      <Tabs
                        style={{ margin: '0 50px' }}
                        onChange={this.switchTab}
                        value={this.state.tabChoice}
                      >
                        <Tab
                          value={0}
                          label={this.trans(
                            'page/paymentupdate/tab/select-charge'
                          )}
                        />
                        <Tab
                          value={1}
                          label={this.trans(
                            'page/paymentupdate/tab/find-charge'
                          )}
                        />
                        <Tab
                          value={2}
                          label={this.trans(
                            'page/paymentupdate/tab/new-charge'
                          )}
                        />
                      </Tabs>
                    )
                }

                {this.state?.showChargesList &&
                  this.state.payment?.amountRemaining > 0 &&
                  !this.state.payment?.removed && (
                    <div
                      className="component-wrapper"
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <div className="component table-row-cursor-container">
                        <Charges2List
                          {...this.props}
                          chargeChoice={this.state.chargeChoice}
                          directIndirectCharges={
                            this.state.directIndirectCharges
                          }
                          selectedDirectIndirectChargesRows={
                            this.state.selectedDirectIndirectChargesRows
                          }
                          objectCharges={this.state.objectCharges}
                          selectedObjectChargesRows={
                            this.state.selectedObjectChargesRows
                          }
                          selectedEntityForExistingCharge={
                            this.state.selectedEntityForExistingCharge
                          }
                          amountForCharge={this.state.amountForCharge}
                          currencyIdForCharge={this.state.currencyIdForCharge}
                          vatForCharge={this.state.vatForCharge}
                          vatPercentageForCharge={
                            this.state.vatPercentageForCharge
                          }
                          showChargeOwnerChoice={
                            this.state.showChargeOwnerChoice
                          }
                          paymentClassId={this.state.paymentClassId}
                          chargeOwnerChoice={this.state.chargeOwnerChoice}
                          selectedPersonForCharge={
                            this.state.selectedPersonForCharge
                          }
                          selectedCompanyForCharge={
                            this.state.selectedCompanyForCharge
                          }
                          selectedPayment={this.state.selectedPayment}
                          typeIdForCharge={this.state.typeIdForCharge}
                          selectedEntityForNewCharge={
                            this.state.selectedEntityForNewCharge
                          }
                          periodForCharge={this.state.periodForCharge}
                          firstDateForCharge={this.state.firstDateForCharge}
                          descriptionForCharge={this.state.descriptionForCharge}
                          scrollToEndOfPage={true}
                          pageName="paymentupdate"
                          chargeClassId={this.state.chargeClassId}
                          isDisabled={isRemoved}
                          disabledChargeChoice={isRemoved}
                          descriptionForChargeIsManuallyChanged={
                            this.state.descriptionForChargeIsManuallyChanged
                          }
                          changeChargeChoiceView={this.changeChargeChoiceView}
                          getCharges={this.getCharges}
                          onDirectInDirectChargeRowSelection={
                            this.onDirectInDirectChargeRowSelection
                          }
                          onObjectChargeRowSelection={
                            this.onObjectChargeRowSelection
                          }
                          selectEntityForExistingCharge={
                            this.selectEntityForExistingCharge
                          }
                          clearEntityForExistingCharge={
                            this.clearEntityForExistingCharge
                          }
                          selectDate={this.selectDate}
                          changeAmountForCharge={this.changeAmountForCharge}
                          changeCurrencyIdForCharge={
                            this.changeCurrencyIdForCharge
                          }
                          changeVatForCharge={this.changeVatForCharge}
                          changeVatPercentageForCharge={
                            this.changeVatPercentageForCharge
                          }
                          changeChargeOwnerChoice={this.changeChargeOwnerChoice}
                          selectPersonForCharge={this.selectPersonForCharge}
                          clearPersonForCharge={this.clearPersonForCharge}
                          selectCompanyForCharge={this.selectCompanyForCharge}
                          clearCompanyForCharge={this.clearCompanyForCharge}
                          changeTypeIdForCharge={this.changeTypeIdForCharge}
                          selectEntityForNewCharge={
                            this.selectEntityForNewCharge
                          }
                          clearEntityForNewCharge={this.clearEntityForNewCharge}
                          changePeriodForCharge={this.changePeriodForCharge}
                          changeDescriptionForCharge={
                            this.changeDescriptionForCharge
                          }
                          isCreateChargeTypePopupOpen={
                            this.state.isCreateChargeTypePopupOpen
                          }
                          addChargeType={this.addChargeType}
                          renderChargeType={this.state.renderChargeType}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(
                            this,
                            `paymentUpdate-${this.state.payment?.id}-`
                          )}
                          chargeTypeSelectField={
                            this.state.paymentClassId ==
                            PaymentClassContainer.pickIdFromLabel('Payable')
                              ? 'Payable'
                              : 'Receivable'
                          }
                          filterClassForType={
                            this.state.paymentClassId ==
                            PaymentClassContainer.pickIdFromLabel('Payable')
                              ? 'payable'
                              : 'receivable'
                          }
                          chargeSearchInProgress={
                            this.state.chargeSearchInProgress
                          }
                          updateChargeSearchString={
                            this.updateChargeSearchString
                          }
                          saveButton={
                            (this.state.selectedDirectIndirectChargesRows
                              .length > 0 ||
                              this.state.selectedObjectChargesRows.length >
                                0) && (
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={this.save.bind(this)}
                                style={{ margin: '12px 12px 0 0' }}
                              >
                                {this.trans('page/entity-button/save')}
                              </Button>
                            )
                          }
                          hideSwitcher={true}
                          hideHeader={true}
                        />
                      </div>
                    </div>
                  )}
              </div>
            </div>

            <div className={'right-panel-wrapper'}>
              {
                <EntityLaunchpanel
                  {...this.props}
                  panelWithMoreButton={{ borderBottom: 0 }}
                  entityTitle={this.trans('launchpanel-payment-title')}
                  actionsList={
                    <List component="div" disablePadding>
                      {!this.state.payment?.isFullyUsed() && (
                        <ListItem
                          button
                          key={`register_the_charge`}
                          alignItems="flex-start"
                          onClick={() => {
                            if (
                              this.checkProcessIsBusy({
                                action: 'link',
                                entityName: 'payment',
                                entity: this.state.payment,
                              })
                            ) {
                              this.openIsBusyPopup();
                              this.setState({ anchorPaymentEl: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorPaymentEl: null,
                                openLeavePrompt: true,
                              });
                            } else {
                              this.setState({
                                // isChargeCreatePopupOpen: true,
                                isCoachNewChargeOpen: true,
                                anchorPaymentEl: null,
                              });
                            }
                          }}
                          style={{ padding: '1px 16px' }}
                        >
                          <ListItemIcon>
                            <div className="icon icon-style-launch-panel icon-ic-charge"></div>
                          </ListItemIcon>
                          <ListItemText
                            primary={this.trans('launch-panel-register-charge')}
                            secondary={this.trans(
                              'hint/launch-panel-register-charge'
                            )}
                          />
                        </ListItem>
                      )}

                      {/* {
                            (this.state.payment?.isReferencedToSavings || this.state.payment?.isSettle) &&
                              <ListItem
                                button
                                key={`menuitem-unsettle-from-savings`}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (this.checkProcessIsBusy({
                                    action: "remove",
                                    entityName: "payment",
                                    entity: this.state.payment
                                  })) {
                                      this.openIsBusyPopup();
                                      this.setState({anchorPaymentEl: null})
                                    } else if(this.state.hasModifiedData) {
                                      this.setState({
                                        isErrorLaunchPanelOpen: true,
                                        anchorPaymentEl: null,
                                        openLeavePrompt: true
                                      })
                                    } else {
                                      if (this.state.payment?.isReferencedToSavings) {
                                        this.setState({
                                          isUndoSavingsPopupOpen: true,
                                          anchorPaymentEl: null
                                        });
                                      } else {
                                        this.setState({
                                          isPaymentUnSettlePopupOpen: true,
                                          anchorPaymentEl: null
                                        });
                                      }
                                    }
                                  }
                                }
                                style={{padding: "1px 16px"}}
                              >
                                <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                                <ListItemText primary={this.trans("payment-details/menuitem-undo-settle-with-savings")} secondary={this.trans("payment-details/hint/menuitem-undo-settle-with-savings")} />
                              </ListItem>
                        } */}

                      <ListItem
                        button
                        key={`send_payment_by_email`}
                        alignItems="flex-start"
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorPaymentEl: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.setState(
                              {
                                hasModifiedData: false,
                                anchorPaymentEl: null,
                              },
                              () => {
                                this.redirect(
                                  `/app/email/send/payment/${
                                    this.state.payment && this.state.payment.id
                                  }`
                                );
                              }
                            );
                          }
                        }}
                        style={{ padding: '1px 16px' }}
                      >
                        <ListItemIcon>
                          <div className="icon icon-style-launch-panel icon-ic-email"></div>
                        </ListItemIcon>
                        <ListItemText
                          primary={this.trans(
                            'launch-panel-send-payment-by-email'
                          )}
                          secondary={this.trans(
                            'hint/launch-panel-send-payment-by-email'
                          )}
                        />
                      </ListItem>

                      <ListItem
                        button
                        key={`add-memo-btn`}
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorPaymentEl: null,
                              openLeavePrompt: true,
                            });
                          } else {
                            this.openMemoPopup(this.state.payment);
                          }
                        }}
                        style={{ padding: '1px 16px' }}
                      >
                        <ListItemIcon>
                          <div
                            className={`icon icon-style-launch-panel ${
                              this.state.payment?.hasMemos
                                ? 'icon-ic-bookmark blue-onhover'
                                : 'icon-ic-memo'
                            }`}
                          ></div>
                        </ListItemIcon>
                        <ListItemText>
                          {this.trans('charge-details/menuitem-open-memo')}
                        </ListItemText>
                      </ListItem>

                      {this.state?.showAllFields && (
                        <>
                          {/* {
                            !this.state.payment?.isFullyUsed() && 
                            this.state.payment?.paymentClass?.label === "Payable" && (
                              <ListItem
                                button
                                key={"agency-costs"}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (this.checkProcessIsBusy({
                                    action: "link",
                                    entityName: "payment",
                                    entity: this.state.payment
                                  })) {
                                    this.openIsBusyPopup();
                                    this.setState({anchorPaymentEl: null})
                                  } else 
                                  if(this.state.hasModifiedData) {
                                    this.setState({
                                      isErrorLaunchPanelOpen: true,
                                      anchorPaymentEl: null,
                                      openLeavePrompt: true
                                    })
                                  } else {
                                    this.setState({
                                      isAgencyCostsPopupOpen: true,
                                      typeIdForCostsCharge: TypeContainer.pickIdFromLabel("Other_payable"),
                                      considerUsedProcess: true,
                                      anchorPaymentEl: null
                                    })
                                  }
                                }}
                                style={{padding: "1px 16px"}}
                              >
                                <ListItemIcon>
                                  <div className="icon icon-style-launch-panel icon-ic-settle"></div>
                                </ListItemIcon>
                                <ListItemText primary={this.trans("menuitem-agency-costs", {agencyName: this.getAgency()?.name})} secondary={this.trans("hint/menuitem-agency-costs")} />
                              </ListItem>
                            )
                          } */}
                          {!this.state.payment?.isFullyUsed() &&
                            (!this.state.payment?.isReferencedToSavings ||
                              (this.state.payment?.isReferencedToSavings &&
                                !this.state.payment?.isFullyUsed())) && (
                              <ListItem
                                button
                                key={'settle-with-savings'}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'settle-savings',
                                      entityName: 'payment',
                                      entity: this.state.payment,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorPaymentEl: null });
                                  } else if (this.state.hasModifiedData) {
                                    this.setState({
                                      isErrorLaunchPanelOpen: true,
                                      anchorPaymentEl: null,
                                      openLeavePrompt: true,
                                    });
                                  } else {
                                    this.setState(
                                      {
                                        anchorPaymentEl: null,
                                      },
                                      () => {
                                        this.setState(
                                          {
                                            anchorPaymentEl: null,
                                          },
                                          () => {
                                            this.settleWithSavingsCheckScenario();
                                          }
                                        );
                                      }
                                    );
                                  }
                                }}
                                style={{ padding: '1px 16px' }}
                              >
                                <ListItemIcon>
                                  <div className="icon icon-style-launch-panel icon-ic-savings"></div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={this.trans(
                                    'menuitem-settlepaymentwithsavings'
                                  )}
                                  secondary={this.trans(
                                    'hint/menuitem-settlepaymentwithsavings',
                                    { agencyName: this.getAgency()?.name }
                                  )}
                                />
                              </ListItem>
                            )}

                          {!this.state.payment?.isFullyUsed() && (
                            <ListItem
                              button
                              key={`settle_this_payment`}
                              alignItems="flex-start"
                              onClick={() => {
                                if (
                                  this.checkProcessIsBusy({
                                    action: 'settle',
                                    entityName: 'payment',
                                    entity: this.state.payment,
                                  })
                                ) {
                                  this.openIsBusyPopup();
                                  this.setState({ anchorPaymentEl: null });
                                } else if (this.state.hasModifiedData) {
                                  this.setState({
                                    isErrorLaunchPanelOpen: true,
                                    anchorPaymentEl: null,
                                    openLeavePrompt: true,
                                  });
                                } else {
                                  this.fetchExistingPayments();

                                  this.setState({
                                    isSettlePaymentPopupOpen: true,
                                    anchorPaymentEl: null,
                                  });
                                }
                              }}
                              style={{ padding: '1px 16px' }}
                            >
                              <ListItemIcon>
                                <div className="icon icon-style-launch-panel icon-ic-pay"></div>
                              </ListItemIcon>
                              <ListItemText
                                primary={this.trans(
                                  'launch-panel-settle-payment'
                                )}
                                secondary={this.trans(
                                  'hint/launch-panel-settle-payment'
                                )}
                              />
                            </ListItem>
                          )}

                          {!this.state.payment?.isFullyUsed() &&
                            this.state.payment?.getPayerDisplayName() && (
                              <ListItem
                                button
                                key={'refund-payment'}
                                alignItems="flex-start"
                                onClick={() => {
                                  if (
                                    this.checkProcessIsBusy({
                                      action: 'refund',
                                      entityName: 'payment',
                                      entity: this.state.payment,
                                    })
                                  ) {
                                    this.openIsBusyPopup();
                                    this.setState({ anchorPaymentEl: null });
                                  } else if (this.state.hasModifiedData) {
                                    this.setState({
                                      isErrorLaunchPanelOpen: true,
                                      anchorPaymentEl: null,
                                      openLeavePrompt: true,
                                    });
                                  } else {
                                    this.checkIfRefundIsPossible(
                                      this.state.payment
                                    );
                                  }
                                }}
                                style={{ padding: '1px 16px' }}
                              >
                                <ListItemIcon>
                                  <div className="icon icon-style-launch-panel icon-ic-replay"></div>
                                </ListItemIcon>
                                <ListItemText
                                  primary={this.trans(
                                    'menuitem-refund-payment'
                                  )}
                                  secondary={this.trans(
                                    'hint/menuitem-refund-payment'
                                  )}
                                />
                              </ListItem>
                            )}

                          <ListItem
                            button
                            key="menuitem-remove"
                            onClick={() => {
                              if (
                                this.checkProcessIsBusy({
                                  action: 'remove',
                                  entityName: 'payment',
                                  entity: this.state.payment,
                                })
                              ) {
                                this.openIsBusyPopup();
                                this.setState({ anchorPaymentEl: null });
                              } else {
                                this.setState({
                                  isPaymentRemovePopupOpen: true,
                                  paymentToDelete: this.state.payment,
                                  anchorPaymentEl: null,
                                });
                              }
                            }}
                            style={{ padding: '1px 16px' }}
                          >
                            <ListItemIcon>
                              <div className="icon icon-style-launch-panel icon-ic-remove"></div>
                            </ListItemIcon>
                            <ListItemText>
                              {this.trans('menuitem-delete-payment')}
                            </ListItemText>
                          </ListItem>
                        </>
                      )}

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          backgroundColor: '#e6e6e6',
                          padding: '6px 0',
                          marginTop: '8px',
                        }}
                        onClick={() =>
                          this.setState({
                            showAllFields: !this.state.showAllFields,
                          })
                        }
                      >
                        {this.state.showAllFields ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                        <div>
                          {this.state.showAllFields
                            ? this.trans('title-less').toUpperCase()
                            : this.trans('title-more').toUpperCase()}
                        </div>
                      </div>
                    </List>
                  }
                />
              }

              {this.isBeta() && (
                <Timeline
                  {...this.props}
                  relations={{
                    paymentId: this.state.payment && this.state.payment.id,
                  }}
                  entityEvents={this.state.events}
                  fetchEntityEvents={this.fetchEntityEvents.bind(
                    this,
                    this.state.payment && this.state.payment.id
                  )}
                  fetchingEvents={this.state.fetchingEvents}
                />
              )}
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans('memo')}
          content={
            <div>
              <Memo
                {...this.props}
                entity={this.state.paymentToAddNote}
                saveDraft={this.saveDraft}
                relations={{ paymentId: this.state.paymentToAddNote?.id }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans('button-close')}
          onSave={() => this.saveReminder(this.state.paymentToAddNote)}
          hideCross={true}
          subtitle={
            this.state.paymentToAddNote &&
            this.state.paymentToAddNote.displayName
              ? this.state.paymentToAddNote.displayName
              : ''
          }
        />

        <SettleWithSavingsDialog
          {...this.props}
          entity={this.state.payment}
          isOpen={this.state.isPaymentSettleWithSavingsPopupOpen}
          settleSavingScenarioMessage={this.state.settleSavingScenarioMessage}
          initializePage={(callback) => {
            this.initializePage(this.state.payment?.id, callback);
          }}
          closeDialog={() =>
            this.setState({ isPaymentSettleWithSavingsPopupOpen: false })
          }
        />

        <UndoSettleWithSavingsDialog
          {...this.props}
          entity={this.state.entityToUnsettleWithSavings || this.state.payment}
          isOpen={this.state.isUndoSavingsPopupOpen}
          initializePage={() => {
            this.initializePage(this.state.payment?.id);
          }}
          closeDialog={() =>
            this.setState({
              isUndoSavingsPopupOpen: false,
              anchorPaymentEl: null,
            })
          }
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={
            'page/paymentupdate-dialog/preprocess-info/chargewillbeunlinked'
          }
          isOpen={this.state.isChargeUnlinkPopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnlinkPopupOpen: false,
            });
          }}
          onDelete={this.unlinkCharge}
          type={'dialog-button/continue'}
        />

        <DeleteEntityPrompt
          {...this.props}
          title={this.trans('page/chargeupdate-preprocess/unrefund-title')}
          entityName={'page/chargeupdate-preprocess/unrefund-info'}
          isOpen={this.state.isChargeUnrefundPopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnrefundPopupOpen: false,
            });
          }}
          onDelete={this.unrefundCharge}
          type={'page/chargeupdate-preprocess/unrefund-button'}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          customTitle={this.trans('discard-changes')}
          customButtons={
            <div>
              <Button
                color="primary"
                onClick={() =>
                  this.setState({ openLeavePrompt: false, nextPath: '' })
                }
              >
                {this.trans('button-cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={
                  this.state.isErrorLaunchPanelOpen
                    ? () =>
                        this.setState({
                          openLeavePrompt: false,
                          hasModifiedData: false,
                          additionalSectionHasModifiedData: false,
                        })
                    : this.leave.bind(this)
                }
              >
                {this.trans('button-discard')}
              </Button>
            </div>
          }
          onClose={() =>
            this.setState({ openLeavePrompt: false, nextPath: '' })
          }
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={
            this.state.isErrorLaunchPanelOpen
              ? () =>
                  this.setState({
                    openLeavePrompt: false,
                    hasModifiedData: false,
                    additionalSectionHasModifiedData: false,
                  })
              : this.leave.bind(this)
          }
          onSave={() => {
            this.setState({ openLeavePrompt: false });
            this.save();
          }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'title-payment-unsettle-from-charge-page-content-dialog'}
          isOpen={this.state.isPaymentUnSettlePopupOpen}
          onCancel={this.closePaymentPrompt}
          onDelete={this.unSettlePayment}
          type="button-unsettle"
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/extrapayment-title')}
          content={
            <div>
              <p>
                {this.trans(
                  'dialog/extrapayment-info/createextrapayment',
                  this.state.detailsForExtraPaymentPopup
                )}
              </p>
              <p>{this.trans('dialog/extrapayment-info/buttonskip')}</p>
            </div>
          }
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          positiveButtonLabel={this.trans(
            'dialog/extrapayment-button/createextrapayment'
          )}
          openLeavePrompt={this.state.createExtraPaymentPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({ createExtraPaymentPopupOpen: false });
          }}
          onSave={() =>
            this.setState(
              {
                createExtraPaymentPopupOpen: false,
                shouldCreateExtraPayment: true,
              },
              this.save
            )
          }
          additionalBtns={[
            <Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateExtraPayment: false,
                    skipCreateExtraPayment: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog-button/skip')}
            </Button>,
            <Button
              variant="contained"
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateExtraPayment: true,
                    shouldSettleTheDifference: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog/extrapayment-button/settlethedifference')}
            </Button>,
          ]}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={
            this.state.payment?.hasTransaction
              ? 'dialog-info/removetransaction'
              : 'title-payment-delete-from-payment-page-content-dialog'
          }
          isOpen={this.state.isPaymentRemovePopupOpen}
          onCancel={this.closePaymentPrompt}
          onDelete={this.deletePayment}
        />

        <PromptDialog
          {...this.props}
          title={this.trans('dialog/extracharge-title')}
          content={
            <div>
              <p>
                {
                  this.state.detailsForAdditionalChargePopup
                    .additionalChargeInformationText
                }
              </p>
              <p>{this.trans('dialog/extracharge-info/buttonskip')}</p>
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={
            this.state.additionalChargePopupOpen &&
            !this.state.isChargeFullyPaid
          }
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          positiveButtonLabel={
            !this.state.isChargeFullyPaid
              ? this.trans('dialog/extracharge-button/createextracharge')
              : null
          }
          onDiscard={() => this.setState({ additionalChargePopupOpen: false })}
          onSave={() =>
            this.setState(
              {
                additionalChargePopupOpen: false,
                shouldCreateAdditionalCharge: true,
              },
              this.save
            )
          }
          additionalBtns={[
            <Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    additionalChargePopupOpen: false,
                    shouldCreateAdditionalCharge: false,
                    skipCreateAdditionalCharge: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog-button/skip')}
            </Button>,
            <Button
              variant="contained"
              key="dialog-additional-btn"
              color="primary"
              onClick={() =>
                this.setState(
                  {
                    createExtraPaymentPopupOpen: false,
                    shouldCreateAdditionalCharge: true,
                    shouldSettleTheDifference: true,
                  },
                  this.save
                )
              }
            >
              {this.trans('dialog/extracharge-button/settlethedifference')}
            </Button>,
          ]}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isRefundPopupOpen}
          title={this.trans('page/paymentupdate-preprocess/refund-title')}
          content={
            <div>
              <div>
                {this.trans('page/paymentupdate-preprocess/refund-info')}
              </div>

              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-amount"
                type="text"
                label={this.trans('label-amount')}
                value={this.state.refundProcessAmount}
                onChange={(e) =>
                  this.setState({ refundProcessAmount: e.target.value })
                }
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor('amount')}
              />
              {!!this.getErrorFor('amount') && (
                <div className="component-error-text">
                  {this.getErrorFor('amount')}
                </div>
              )}

              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-description"
                type="text"
                multiline
                rowsMax="25"
                rows="3"
                label={this.trans('description')}
                value={this.state.refundProcessDescription}
                onChange={(e) =>
                  this.setState({ refundProcessDescription: e.target.value })
                }
                variant="standard"
                error={!!this.getErrorFor('description')}
              />
              {!!this.getErrorFor('description') && (
                <div className="component-error-text">
                  {this.getErrorFor('description')}
                </div>
              )}
            </div>
          }
          positiveButtonLabel={this.trans(
            'page/paymentupdate-preprocess/refund-button'
          )}
          negativeButtonLabel={this.trans('dialog-button/cancel')}
          onSave={() =>
            this.setState({ isRefundPopupOpen: false }, () =>
              this.refund(this.state.payment)
            )
          }
          onDiscard={() =>
            this.setState({
              isRefundPopupOpen: false,
              refundProcess: false,
              refundProcessAmount: Formatter.simpleFormatNumber(
                this.state.payment?.amountRemaining
              ),
              refundProcessDescription: this.trans('refund_receivable'),
            })
          }
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'title-payment-unlink-from-payment-page-content-dialog'}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={this.closePaymentPrompt}
          onDelete={this.unlinkPayment}
          type="button-unlink"
        />

        <ChargeCreateDialog
          {...this.props}
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans('title-new-charge')}
          payment={this.state.payment}
          onSaveCallback={this.initializePage.bind(
            this,
            this.state.payment?.id
          )}
          onCancel={() => {
            this.setState({
              isChargeCreatePopupOpen: false,
            });
          }}
        />

        {this.state.isCoachNewChargeOpen && (
          <CoachNewChargeBasedOnPayment
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            payment={this.state.payment}
            initializePage={this.initializePage}
            onCloseCoach={() => {
              this.setState(
                {
                  // isSaving: true,
                  isCoachNewChargeOpen: false,
                }
                // () => this.initializePage(this.state.payment?.id)
              );
            }}
          />
        )}

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={
            this.state.openCoachCreateNewCounterparty
          }
          onCloseCounterpartyCoach={(entity) => {
            if (entity) {
              this.setState(
                {
                  openCoachCreateNewCounterparty: false,
                },
                () => {
                  this.selectCounterpartyForCostsCharge(entity);
                }
              );
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false,
              });
            }
          }}
        />

        {this.state.payment && (
          <CoachSettlePayment
            {...this.props}
            isOpen={this.state.isSettlePaymentPopupOpen}
            payment={this.state.payment}
            initializePage={this.initializePage}
            onCloseCoach={() => {
              this.props.dispatch({
                type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR,
              });

              this.setState({
                isSettlePaymentPopupOpen: false,
                isSaving: false,
              });
            }}
          />
        )}

        {this.state.payment && (
          <CoachPaymentCostsForAgency
            {...this.props}
            isOpen={this.state.isAgencyCostsPopupOpen}
            payment={this.state.payment}
            initializePage={this.initializePage}
            onCloseCoach={() => {
              this.setState({
                isAgencyCostsPopupOpen: false,
                considerUsedProcess: false,
                isSaving: false,
              });
            }}
          />
        )}

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    charges: state.charges,
    payments: state.payments,
    units: state.units,
    properties: state.properties,
    component: state.paymentUpdate,
    globalTypes: state.globalTypes,
    bankAccountCreate: state.bankAccountCreate,
    paymentCardView: state.paymentCardView,
    test: state.bankTransactions,
  };
};

export default connect(mapStateToProps)(PaymentUpdate);
